import React, { createRef } from "react";

import BaseElem from "BaseElem";
import "Common.css";
import "./VisitDraftsListView.css";
import { connect } from "react-redux";
import {
  setAllVisitChecked,
  setVisitChecked,
  deleteVisitDrafts,
  updateLocalVisitDrafts,
  saveOrUpdateVisitDrafts,
  DRAFT_TYPE_UPDATE,
  DRAFT_TYPE_MOBILE,
  DRAFT_TYPE_NEW,
  DRAFT_TYPE_ENTERPRISE,
  DRAFT_TYPE_PENDING_PAYMENT,
} from "Actions/VisitDraftActions";
import { resetPricingAll } from "Actions/PricingActions";
import {
  LoadingSpinner,
  OkCancelDialog,
  PortalDialog,
  PureComp,
} from "Components/CommonComponents";
import {
  parseDate,
  toISOLocal,
  calculateDurationHourMinute,
  fixVisitStartDate,
  fixVisitEndDate,
  convertToDestTZ,
  fixVisitEndTime,
} from "Util/DateUtils";
import Checkbox from "@material-ui/core/Checkbox";
import { Close, HourglassEmpty } from '@mui/icons-material';
import { IconButton, Button } from "@material-ui/core";
import { DateTimeDisplay } from "../DateTimeDisplay";
import {
  UNDEF,
  MSG_OPEN_VISIT_DIALOG,
  MSG_SHOW_UPDATE_REVIEW,
  MSG_SHOW_SNACKBAR,
  API_UPDATE_DRAFTS_DELETE,
  MSG_FETCH_VISITS,
  MSG_SHOW_CALENDAR_VIEW,
  c4A4A4A,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL,
  MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PREFERREDCAREPRO,
} from "Constants";
import { getLocationText, LocationInput } from "../LocationInput";
import { AdlServices } from "../AdlServices";
import MedicalServices from "Components/MedicalServicesDropdown";
import { withRouter, RouteComponentProps } from "react-router-dom";
import PricingEngine from "Screens/Pricing/PricingEngineIndex";
import VisitUpdateReview from "../VisitUpdateReview/VisitUpdateReview";
import { NursingProcedures } from "../NursingProcedures";
import { TextDropdown } from "../TextDropdown";
import {
  NURSE_REQUIREMENTS,
  MOBILITY_TYPES,
  VISIT_BREAK_OPTIONS,
  MAX_CPS_FOR_VISIT,
  required_cp,
  breaks,
  visit_schedule,
  visit_location_address,
  requested_services,
  medical_conditions,
  meal_requirements,
  nursing_procedure,
  home_rehabilitation,
  home_medical,
  special_requests_instructions,
  ambulant,
  is_nurse_required,
  is_nurse_requested,
  reason_for_nurse,
  mobility_instruction,
  has_manual_transfer,
  manual_transfer_help,
  manual_transfer_help_details,
  transfer_points,
  bed,
  transfer_type,
  require_vital_sign,
  internal_ops_cr_note,
  internal_ops_fulfillment_note,
  STATUS_OPEN,
  STATUS_REQUESTED,
  STATUS_CONFIRMED,
  STATUS_PARTIALLY_CONFIRMED,
  MEDICAL_ESCORT,
  medical_escort_details,
  home_medical_details,
  procedures,
  therapy_details,
  COMPANIONSHIP,
  companionship_description,
  BASIC_CONSULTATION,
  PHYSIOTHERAPY,
  SPEECH_THERAPY,
  blob_urls,
  doctor_memo_available,
  OCCUPATIONAL_THERAPY,
  expected_outcome,
  doctor_memo,
  isSG,
  isMY,
  isAU,
  have_hoist,
  co_accept_2_cps,
  assigned_carepros,
  APP_COUNTRY,
  preferred_cps,
  preferred_cps_list_by_service,
  preferred_cps_option,
  hard_soft_value_designation,
  co_preferred_timing_obj
} from "DataConstants";
import { PAGINATE_PAGE_COUNT } from "Constants";
import { InputField } from "../InputField";
import {
  clamp,
  postMessage,
  cleanTextForMobileCompatibility,
  isObjEmpty,
  isBlank,
} from "Util/Utilities";
import { DIALOG_TYPE } from "Components/Dialogs/VisitDialog/types";
import {
  ADDED_VISITS,
  CUSTOMER_REQUEST_DATE,
  IS_PRICING_UPDATE,
  IS_FROM_DEEPLINK,
} from "Components/Dialogs/DialogCompUpdateVisit";
import Api from "Api";
import { isB2b } from "Screens/ManageCareRecipientB2C/ManageCareRecipient";
import {
  TherapyDetails,
  Visit,
  VisitLocationAddress,
} from "../../@types/PricingModels";
import {
  havePatientDeclaration,
  PatientDeclarationDisplay,
  validatePatientDeclaration,
} from "../PatientDeclaration/PatientDeclaration";
import { Div, Txt } from "../GenericView";
import {
  getMedicalEscortDetails,
  getMedicalEscortError,
} from "../MedicalEscort/MedicalEscort";
import DoctorsMemo from "Screens/CareOwner/MemoTask/DoctorsMemo";
import { UploadData } from "../SharedComponents/MultiUpload";
import {
  AdditionalRequirementsInfo,
  fixManualTransfer,
} from "../Dialogs/AdditionalRequirements";
import moment from "moment";
import LocationDropdown from "../LocationDropdown";
import SelectPreferredCarePros from "Components/Dialogs/VisitDialog/SelectPreferredCarePros";
import { HardSoftPreferenceForListView } from "Components/HardSoftPreferenceForListView";
import FlexibleVisitTiming from "Components/Dialogs/VisitDialog/FlexibleVisitTiming";

export const nurse_error = "nurse_error",
  break_error = "break_error";

type ListViewProps = {
  visitDraftStore?: any;
  recipientStore?: any;
  match: any;
  totalPage?: number;
  coId?: string;
  vwoId?: string;
};

type ListViewState = {
  visits: Array<Object>;
  allChecked: boolean;
  pricingEngineOpen: boolean;
  updateReviewOpen: boolean;
  errors: any;
  servicesError?: boolean;
  currentPage: number;

  // show a dialog when ca report not published
  _showNoCADialog?: boolean;
  _errDlgMsg?: string;

  // when resuming visits update (from update drafts)
  _showCondChangeDialog?: boolean;
  _condChangeMsg?: string;

  // Continue update drafts data to pass to Review & Confirm page
  _reviewUpdateData?: any;
  _showDiscardUpdateDraft?: boolean;
};

type ListViewConnectProps = {
  setAllVisitChecked: (checked: boolean, type: string) => void;
  setVisitChecked: (visitId: string, checked: boolean, type: string) => void;
  deleteVisitDrafts: (
    visitDraftIds: Array<string>,
    isDeleteAll: boolean,
    type: string
  ) => void;
  updateLocalVisitDrafts: (updateObjects: any[], type: string) => void;
  saveOrUpdateVisitDrafts: (
    crId: string,
    visitDrafts: Array<any>,
    type: string
  ) => void;
  resetPricingAll: () => void;
};

type ListViewActualProps = ListViewConnectProps &
  ListViewProps &
  RouteComponentProps<any>;

export function getDraftsType(props: any) {
  const store = props.visitDraftStore;
  return (store && store.draftsType) || DRAFT_TYPE_NEW;
}

export function getUpdateData(props: any) {
  const store = props.visitDraftStore;
  if (store && store.draftsType === DRAFT_TYPE_UPDATE)
    return store.updateVisitsData;
}

export function getDraftVisits(props: any) {
  const store = props.visitDraftStore;
  if (!store) return [];

  const type = store.draftsType;
  const isUpdatingVisits = type === DRAFT_TYPE_UPDATE;
  const isMobileVisits = type === DRAFT_TYPE_MOBILE;
  const isEntVisits = type === DRAFT_TYPE_ENTERPRISE;

  if (isUpdatingVisits) {
    // This should have valid value when updating visits
    //  data comes from DialogCompUpdateVisit.tsx -> getRequestBody() or update draft api
    const updateVisitsData = store.updateVisitsData;

    //if(updateVisitsData.conditions_changed === false) {
    // going straight to "Review & Confirm" page
    //  return [];  // this is to prevent errors on this page
    //}

    const updateVisits = isUpdatingVisits && updateVisitsData[ADDED_VISITS];
    return updateVisits || [];
  } else if (isMobileVisits) {
    return store.savedMobileDrafts || [];
  } else if (isEntVisits) {
    return store.savedEntDrafts || [];
  }
  return store.savedVisitDrafts || [];
}

export function getCustomerRequestdate(props: any): Date | undefined {
  const data = getUpdateData(props);
  return data && data[CUSTOMER_REQUEST_DATE];
}

class VisitDraftsListView extends BaseElem<ListViewActualProps, ListViewState> {
  addlReqRef = createRef<any>();
  medEscRef = createRef<any>();
  patientDeclRef = createRef<any>();
  isDateUpdated = createRef<any>();
  careProDetailsRef = createRef<any>();

  _isPricingUpdate = false;

  constructor(props: ListViewActualProps) {
    super(props);
    const self = this;
    const state: ListViewState = {
      visits: [],
      allChecked: true,
      pricingEngineOpen: false,
      updateReviewOpen: false,
      errors: {},
      currentPage: 1,
    };

    // continuing from update drafts
    const data = getUpdateData(props);
    data && (self._isPricingUpdate = data[IS_PRICING_UPDATE]);

    if (data && data._id) {
      const conditionsChanged = data && data.conditions_changed;

      let firstVisit: any;
      const validStatuses = [
        STATUS_OPEN,
        STATUS_REQUESTED,
        STATUS_CONFIRMED,
        STATUS_PARTIALLY_CONFIRMED,
      ];
      //let removedCount = 0;

      // transform the visits to listview visits format
      const listviewVisits = data[ADDED_VISITS].map((v: any) => {
        if (!validStatuses.includes(v.original_visit.status.visit)) {
          //removedCount++;
          return UNDEF;
        }
        const visit = v.updated_visit;
        if (!visit._id) {
          visit._id = v.visit_id;
        }
        if (!firstVisit) {
          firstVisit = v.original_visit;
        }
        return visit;
      }).filter((v: any) => !!v);

      const dataCopy = Object.assign({}, data);

      data.originalVisit = firstVisit;
      data[ADDED_VISITS] = listviewVisits;
      //delete dataCopy._id;

      if (conditionsChanged === false) {
        state.updateReviewOpen = true;
        state._reviewUpdateData = dataCopy;
      } else if (conditionsChanged === true) {
        // const msg = 'Some things have changed since your last update session. ' +
        // (removedCount === 0 ? '' : `${removedCount} visit${removedCount > 1 ? 's' : ''} have been removed from draft. `)
        // 'Changes on the visits requirements are already reflected. Please continue again from here.';
        const msg =
          "The original visit(s) were updated after you saved your draft. Please double-check the latest visit requirements.";

        state._showCondChangeDialog = true;
        state._condChangeMsg = msg;
      }
      state._showDiscardUpdateDraft = true;
    }

    self.state = state;
  };

  _setPreferredCPListForADLorNursingServices(visit: any) {
    const preferredCPsIsDisabled = !visit?.preferred_cps;
    if (preferredCPsIsDisabled) {
      return {};
    };

    const noPersonalServicesSelected = visit?.requested_services?.length === 0 && visit?.nursing_procedure?.length === 0;

    if (noPersonalServicesSelected) {
      return { home_personal_care: [], home_therapy: [], home_medical: [] };
    };

    const visitAlreadyHasPCPList = visit?.preferred_cps_list_by_service?.home_personal_care?.length > 0;
    if (visitAlreadyHasPCPList) {
      return visit?.preferred_cps_list_by_service;
    };


    // set the list based on API value
    const preferredCPsListFromAPI = this.props.recipientStore?.careRecipient?.cr?.preferred_cps_list_by_service;

    return { home_personal_care: preferredCPsListFromAPI?.home_personal_care, home_therapy: [], home_medical: [] };
  };

  _setPreferredCPListForHomeTherapyServices(visit: any) {
    const preferredCPsIsDisabled = !visit?.preferred_cps;
    if (preferredCPsIsDisabled) {
      return {};
    };

    const noTherapyServicesSelected = visit?.home_rehabilitation?.length === 0;

    if (noTherapyServicesSelected) {
      return { home_personal_care: [], home_therapy: [], home_medical: [] };
    };

    const visitAlreadyHasPCPList = visit?.preferred_cps_list_by_service?.home_therapy?.length > 0;
    if (visitAlreadyHasPCPList) {
      return visit?.preferred_cps_list_by_service;
    };

    // set the list based on API value
    const preferredCPsListFromAPI = this.props.recipientStore?.careRecipient?.cr?.preferred_cps_list_by_service;

    return { home_personal_care: [], home_therapy: preferredCPsListFromAPI?.home_therapy, home_medical: [] };
  };

  _setPreferredCPListForHomeMedicalServices(visit: any) {
    const preferredCPsIsDisabled = !visit?.preferred_cps;
    if (preferredCPsIsDisabled) {
      return {};
    };

    const noMedicalServicesSelected = visit?.home_medical?.length === 0;

    if (noMedicalServicesSelected) {
      return { home_personal_care: [], home_therapy: [], home_medical: [] };
    };

    const visitAlreadyHasPCPList = visit?.preferred_cps_list_by_service?.home_therapy?.length > 0;
    if (visitAlreadyHasPCPList) {
      return visit?.preferred_cps_list_by_service;
    };

    // set the list based on API value
    const preferredCPsListFromAPI = this.props.recipientStore?.careRecipient?.cr?.preferred_cps_list_by_service;

    return { home_personal_care: [], home_therapy: [], home_medical: preferredCPsListFromAPI?.home_medical };
  };


  _onDialogClosedFromAddRequirements = (receivedMessage: string, payload: any) => {

    if (!payload || receivedMessage !== MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS) {
      return;
    };

    const popupVisits = payload.popupVisits;
    const isApplyAll = payload.isApplyAll;
    const currentVisit = payload.currentVisit;
    const isApplyToAll = payload.isApplyToAll;

    const updatedVisit = popupVisits[0];
    if (updatedVisit) {
      const MTProps = [
        has_manual_transfer,
        require_vital_sign,
        manual_transfer_help,
        manual_transfer_help_details,
        transfer_points,
        bed,
        transfer_type,
        have_hoist,
        co_accept_2_cps,
        required_cp,
      ];

      for (let k = 0; k < MTProps.length; k++) {
        const prop = MTProps[k];
        if (updatedVisit[prop] !== UNDEF) {
          currentVisit[prop] = updatedVisit[prop];
        } else {
          delete currentVisit[prop];
        }
      }

      fixManualTransfer(currentVisit);

      let visits = [];
      if (isApplyAll || isApplyToAll) {
        visits = this._allSelected(currentVisit);
        this._showSnackbar();
      }

      for (let i = visits.length; i--;) {
        for (let k = 0; k < MTProps.length; k++) {
          const prop = MTProps[k];
          if (currentVisit[prop] !== UNDEF) {
            visits[i][prop] = currentVisit[prop];
          } else {
            delete visits[i][prop];
          }
        }
      }

      visits.push(currentVisit);
      this._update(visits);
    }
  };

  _onDialogClosedFromMedEscort = (receivedMessage: string, payload: any) => {

    if (!payload || receivedMessage !== MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT) {
      return;
    };

    const popupVisits = payload.popupVisits;
    const isApplyAll = payload.isApplyAll;
    const currentVisit = payload.currentVisit;
    const isApplyToAll = payload.isApplyToAll;

    const updatedVisit = popupVisits[0];
    if (updatedVisit) {
      const details = updatedVisit[medical_escort_details];

      let visits = [currentVisit];
      if (isApplyAll || isApplyToAll) {
        visits = this
          ._allSelected()
          .filter((cv: Visit) => !isBlank(cv[requested_services]));
        this._showSnackbar();
      }

      for (let i = visits.length; i--;) {
        let adls = visits[i][requested_services] || [];

        if (!isObjEmpty(details)) {
          visits[i][medical_escort_details] = details;
          if (!adls.includes(MEDICAL_ESCORT)) {
            adls.push(MEDICAL_ESCORT);
          }
        } else {
          delete visits[i][medical_escort_details];
          adls = adls.filter((a: string) => a !== MEDICAL_ESCORT);
        }

        visits[i][requested_services] = adls;
      }

      this._update(visits);
    } else {
      // clear medical escort entry when popup is cancelled and no details previously selected
      let visits = [currentVisit];
      if (isApplyAll || isApplyToAll) {
        visits = this._allSelected();
      }

      for (let i = visits.length; i--;) {
        const v = visits[i];
        const adls = v[requested_services] || [];

        const details = v[medical_escort_details];
        if (isObjEmpty(details) && adls.includes(MEDICAL_ESCORT)) {
          v[requested_services] = adls.filter(
            (a: string) => a !== MEDICAL_ESCORT
          );
        }
      }
      this._update(visits);
    };
  };


  _onDialogClosedFromPatientDecl = (receivedMessage: string, payload: any) => {

    if (!payload || receivedMessage !== MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL) {
      return;
    };

    const popupVisits = payload.popupVisits;
    const isApplyAll = payload.isApplyAll;
    const currentVisit = payload.currentVisit;
    const isApplyToAll = payload.isApplyToAll;

    const updatedVisit = popupVisits[0];
    if (updatedVisit) {
      const details = updatedVisit[home_medical_details];
      if (!isObjEmpty(details)) {
        currentVisit[home_medical_details] = details;
      } else {
        delete currentVisit[home_medical_details];
      }

      let visits = [];
      if (isApplyAll || isApplyToAll) {
        visits = this._allSelected(currentVisit).filter((cv: any) => {
          const homeMedValue = (cv[home_medical] || [])[0];
          const isBasicConsultation =
            !isHomeMedicalDisabled(cv) &&
            homeMedValue === BASIC_CONSULTATION;
          return isBasicConsultation;
        });
        this._showSnackbar(visits.length + 1);
      }

      for (let i = visits.length; i--;) {
        const details = currentVisit[home_medical_details];
        if (!isObjEmpty(details)) {
          visits[i][home_medical_details] = details;
        } else {
          delete visits[i][home_medical_details];
        }
      }

      visits.push(currentVisit);
      this._update(visits);
    };
  };

  _onDialogClosedFromPreferredCarePro = (receivedMessage: string, payload: any) => {

    if (!payload || receivedMessage !== MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PREFERREDCAREPRO) {
      return;
    };

    const popupVisits = payload.popupVisits;
    const isApplyAll = payload.isApplyAll;
    const currentVisit = payload.currentVisit;
    const isApplyToAll = payload.isApplyToAll;


    const updatedVisit = popupVisits[0];

    if (updatedVisit) {

      const details = updatedVisit[preferred_cps_list_by_service];
      if (!isObjEmpty(details)) {
        currentVisit[preferred_cps_list_by_service] = details;
      } else {
        delete currentVisit[preferred_cps_list_by_service];
      }

      let visits = [currentVisit];

      // TODO: apply all logic needs to be properly setup for multiple visits
      // if (isApplyAll || isApplyToAll) {
      //   visits = self._allSelected(currentVisit);
      //   self._showSnackbar();
      // }

      for (let i = visits.length; i--;) {
        const details = currentVisit[preferred_cps_list_by_service];
        if (!isObjEmpty(details)) {
          visits[i][preferred_cps_list_by_service] = details;
        } else {
          delete visits[i][preferred_cps_list_by_service];
        }
      }

      this._update(visits);
    };

  };


  _onMessageReceived = (event: any) => {
    const receivedMessage = event.data.message;
    const payload = event.data.payload;

    this._onDialogClosedFromAddRequirements(receivedMessage, payload);

    this._onDialogClosedFromMedEscort(receivedMessage, payload);

    this._onDialogClosedFromPatientDecl(receivedMessage, payload);

    this._onDialogClosedFromPreferredCarePro(receivedMessage, payload);
  };


  componentDidMount() {
    const self = this,
      props = self.props;
    props.setAllVisitChecked(true, getDraftsType(props));
    self.listen(MSG_SHOW_UPDATE_REVIEW);

    if (self._isPricingUpdate) {
      self.continueToPricing();
    }
    window.addEventListener("message", this._onMessageReceived);
  };

  componentWillUnmount() {
    this.unlisten(MSG_SHOW_UPDATE_REVIEW);
    window.removeEventListener("message", this._onMessageReceived);
  };

  onMessage(messageName: string, payload?: any) {
    const self = this;
    switch (messageName) {
      // callback from pricing engine
      case MSG_SHOW_UPDATE_REVIEW:
        payload.conditions_changed = true;
        self.setState({
          updateReviewOpen: true,
          pricingEngineOpen: false,
          _reviewUpdateData: payload,
        });
        break;
    }
  }

  formatPreferredCareProPayloadData = (givenVisit: any) => {
    const givenVisitClone = JSON.parse(JSON.stringify(givenVisit));

    const { preferred_cps_list_by_service } = givenVisitClone;

    const listOfIDs: Array<string> = [];
    const personal_care = preferred_cps_list_by_service.home_personal_care;
    const therapy = preferred_cps_list_by_service.home_therapy;
    const medical = preferred_cps_list_by_service.home_medical;

    if (personal_care) {
      personal_care.forEach((carepro: any) => listOfIDs.push(carepro.id));
    }
    if (therapy) {
      therapy.forEach((carepro: any) => listOfIDs.push(carepro.id));
    }
    if (medical) {
      medical.forEach((carepro: any) => listOfIDs.push(carepro.id));
    }

    givenVisitClone.preferred_cps_list_by_service = listOfIDs;

    return givenVisitClone;
  }

  formatVisitDraftFormDataForAPIRequestPayloadUsage = (givenProps: any) => {
    if (!givenProps) {
      return givenProps;
    };

    let propsClone = JSON.parse(JSON.stringify(givenProps));
    const visitDraftStore = propsClone.visitDraftStore;

    const { savedVisitDrafts } = visitDraftStore;
    if (!savedVisitDrafts) {
      return givenProps;
    }

    const formattedVisitDrafts: Array<any> = [];

    // Go through each visit, and modify any data accordingly
    savedVisitDrafts.forEach((visit: any) => {
      // Check for Preferred Care Pros
      if (Object.hasOwn(visit, preferred_cps_list_by_service)) {
        const formattedVisit = this.formatPreferredCareProPayloadData(visit);
        formattedVisitDrafts.push(formattedVisit);
      } else {
        formattedVisitDrafts.push(visit);
      }
    });

    propsClone.visitDraftStore.savedVisitDrafts = formattedVisitDrafts;

    return propsClone;
  }

  // newly created visit drafts or mobile drafts
  saveVisitDrafts = () => {
    const props = this.props,
      crId = props.match.params.id,
      type = getDraftsType(props);

    const formattedVisitDrafts = this.formatVisitDraftFormDataForAPIRequestPayloadUsage(props);

    props.saveOrUpdateVisitDrafts(crId, getDraftVisits(formattedVisitDrafts), type);
  };

  // delete new visit drafts
  handleDelete = (_event: any) => {
    const props = this.props;
    const selectedVisitDraftIds = getDraftVisits(props)
      .filter((visitDraft: any) => visitDraft.selected)
      .map((visitDraft: any) => visitDraft._id);
    props.deleteVisitDrafts(selectedVisitDraftIds, true, getDraftsType(props));
  };

  hasSelected(): boolean {
    let self = this,
      drafts = getDraftVisits(self.props);
    if (drafts && drafts[0]) {
      let selectedVisits = drafts.filter((visit: any) => visit.selected);
      return selectedVisits.length > 0;
    }
    return false;
  }

  _closeConditionsChangeDialog() {
    this.setState({ _showCondChangeDialog: false });
  }
  _discardUpdateDraft = () => {
    const self = this,
      updateData = getUpdateData(self.props);
    const id = updateData && updateData._id;
    id &&
      Api.POST(API_UPDATE_DRAFTS_DELETE, { draft_ids: [id] }, (resp) => {
        if (resp) {
          self._closeConditionsChangeDialog();
          postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
          postMessage(MSG_FETCH_VISITS, { spinnerDuration: 1000 }, 500);
        }
      });
  };

  getRegion = () => {
    const { recipientStore } = this.props;
    const timezone = recipientStore?.careRecipient?.cr?.timezone;
    let region = timezone.timezones[APP_COUNTRY];
    if (timezone?.is_single_tz === false) {
      const city = recipientStore?.careRecipient?.co?.address_list?.[0]?.city;
      region = timezone.timezones[city];
    }
    return region;
  };

  _isRecipientMobilityCDEWithSpecificServicesforSingapore = (visit: any): boolean => {

    const isMobilityCDE = ['Level C', 'Level D', 'Level E'].indexOf(visit.ambulant) > -1;
    const selectedPersonalCare = visit.requested_services.indexOf("Personal Care & Hygiene") > -1;
    const selectedToileting = visit.requested_services.indexOf("Toileting") > -1;
    const selectedStayingActive = visit.requested_services.indexOf("Staying Active") > -1;
    const selectedMedicalEscort = visit.requested_services.indexOf("Medical Escort") > -1;
    const hasSpecificServices = selectedPersonalCare || selectedToileting || selectedStayingActive || selectedMedicalEscort;

    return isSG && isMobilityCDE && hasSpecificServices;
  }

  _checkIfManualTransferNeededBeforeProceeding = (visit: any): boolean => {

    if (visit?.visit_status === 'Completed') {
      // Visit was completed, and likely being updated for an incident. Check not needed.
      return false;
    };

    const self = this;

    if (self._isRecipientMobilityCDEWithSpecificServicesforSingapore(visit)) {

      // 1. Manual transfer is selected but Additional help has not been set to YES or NO yet
      if (visit.has_manual_transfer && visit.manual_transfer_help === UNDEF) {
        return true;
      };

      // 2. Invalidate the form if Transfer Help is YES but text is not filled in
      if (visit.manual_transfer_help === true && !visit.manual_transfer_help_details) {
        return true;
      }

    }
    return false;
  }

  // error checking, validation
  checkDraftForErrors = () => {
    const self = this,
      props = self.props;
    const visitDrafts = getDraftVisits(props);
    let errors: any = {};
    let hasError = false;

    let servicesJson = "";
    let servicesError = false; // Only same types of services allowed to continue
    let isHPCVisit = false;
    let isHMVisit = false;
    let isSTVisit = false;
    let isOTVisit = false;
    let isPTVisit = false;
    const data = getUpdateData(props);
    const isFromDeeplink = data && data[IS_FROM_DEEPLINK];

    visitDrafts.forEach((draft: any, index: number) => {
      if (!draft.selected) {
        return;
      }

      const draftErrors: any = {};
      const requestedServices = draft[requested_services];
      const selectedMedicals = draft[medical_conditions];
      const mealArrangement = draft[meal_requirements];
      const homeRehabilitation = draft[home_rehabilitation];
      const homeMedical = draft[home_medical];
      const nursingProcedure = draft[nursing_procedure];
      const mobility = draft[ambulant];
      const address = draft[visit_location_address];
      const isNurseRequested = draft[is_nurse_requested];
      const isNurseRequired = draft[is_nurse_required];
      const reasonForNurse = draft[reason_for_nurse];

      const haveAdl = requestedServices && requestedServices.length;
      const haveNursing = nursingProcedure && nursingProcedure.length;
      const haveTherapy = homeRehabilitation && homeRehabilitation.length;
      const haveMedical = homeMedical && homeMedical.length;
      const homeMedValue = (homeMedical || [])[0];
      const hmDetails = (haveMedical && draft[home_medical_details]) || {};
      const isBasicConsultation =
        haveMedical && homeMedValue === BASIC_CONSULTATION;

      if (!haveAdl && !haveNursing && !haveTherapy && !haveMedical) {
        draftErrors[requested_services] =
          draftErrors[nursing_procedure] =
          draftErrors[home_rehabilitation] =
          draftErrors[home_medical] =
          "No services are selected";
      } /*else {
        if ((haveAdl || haveNursing) && haveTherapy) {
          draftErrors[requested_services] = 
          draftErrors[nursing_procedure] = 
          draftErrors[home_rehabilitation] = 
          'ADL and nursing procedures cannot be selected with therapy services';          
        }
      }*/

      if (haveAdl) requestedServices.sort();
      if (mealArrangement) mealArrangement.sort();
      if (haveNursing)
        nursingProcedure.sort((a: any, b: any) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
      if (haveTherapy) homeRehabilitation.sort();
      if (haveMedical) homeMedical.sort();

      if (haveAdl || haveNursing) isHPCVisit = true;
      if (haveMedical) isHMVisit = true;

      const therapyType = homeRehabilitation && homeRehabilitation[0];
      const therapyDetails = draft[therapy_details] || {};
      if (therapyType === OCCUPATIONAL_THERAPY) isOTVisit = true;
      if (therapyType === PHYSIOTHERAPY) isPTVisit = true;
      if (therapyType === SPEECH_THERAPY) isSTVisit = true;

      const jsonString = JSON.stringify([
        requestedServices,
        mealArrangement,
        nursingProcedure,
        homeRehabilitation,
        homeMedical,
        isNurseRequested,
        isNurseRequired,
        mobility,
      ]);
      if (!servicesJson) {
        servicesJson = jsonString;
      } else if (servicesJson !== jsonString) {
        servicesError = true;
      }

      // Mobility level is not for home medical
      if (!mobility && !haveMedical) {
        draftErrors[ambulant] = "Mobility level not selected";
      }

      if (self._checkIfManualTransferNeededBeforeProceeding(draft)) {
        draftErrors[has_manual_transfer] = "Please provide additional details";
      }

      // check for missing companionship description
      if (
        haveAdl &&
        requestedServices.includes(COMPANIONSHIP) &&
        isBlank(draft[companionship_description])
      ) {
        draftErrors[requested_services] =
          "Companionship description is missing";
      }

      // For "Occupational Therapy" validate expected outcome field
      if (isOTVisit && isBlank(therapyDetails[expected_outcome])) {
        draftErrors[home_rehabilitation] = "Please specify expected outcome";
      }

      // For "Physiotherapy" and "Speech Therapy" validate doctor memo
      if (
        (isPTVisit || isSTVisit) &&
        therapyDetails[doctor_memo_available] !== false &&
        isBlank(therapyDetails[doctor_memo])
      ) {
        draftErrors[home_rehabilitation] = "Doctor's memo not specified";
      }

      // Validate "Home Medical"
      if (isBasicConsultation && !validatePatientDeclaration(hmDetails)) {
        draftErrors[home_medical_details] =
          "Patient Declaration details are missing";
      }

      if (draft[co_preferred_timing_obj]) {
        let visitTimingFlexibility = draft[co_preferred_timing_obj].flexible_visit_timing;
        let startTime = draft[co_preferred_timing_obj].start_time;
        let endTime = draft[co_preferred_timing_obj].end_time;

        if (!visitTimingFlexibility) {
          draftErrors[co_preferred_timing_obj] = "Visit timing flexibility not specified";
        } else if (visitTimingFlexibility === "Yes" && (!startTime || !endTime)) {
          draftErrors[co_preferred_timing_obj] = "Start and end time not selected";
        }
      }

      if (draft[visit_schedule]) {
        let dateFrom = draft[visit_schedule]["date_from"];
        let dateTo = draft[visit_schedule]["date_to"];

        if (!dateFrom) {
          draftErrors[visit_schedule] = "Start date not selected";
        } else if (!dateTo) {
          draftErrors[visit_schedule] = "End date not selected";
        } else {
          dateFrom = parseDate(dateFrom);
          dateTo = parseDate(dateTo);
          let today = new Date();
          if (dateFrom > dateTo) {
            draftErrors[visit_schedule] = "Start date later than end date";
          }
          if (!isFromDeeplink && today > dateFrom) {
            draftErrors[visit_schedule] = "Visit is scheduled in the past";
          }

          // check if visit is too close, disable the create/update flow
          const isHPC = this.props.location.pathname.includes("/hpc");
          if (
            isHPC &&
            (!draft.status ||
              draft.status.visit === "Open" ||
              draft.status.visit === "Requested")
          ) {
            const currentTime = moment(
              convertToDestTZ(new Date(), this.getRegion() ?? "") || new Date()
            );
            const startTime = moment(
              convertToDestTZ(dateFrom, this.getRegion())
            );
            const cutOffTime =
              this.props.recipientStore?.careRecipient?.co
                ?.visit_too_close_time ?? 1;
            const incidentCenter = window.location.search.includes(
              "source=incident-centre"
            );
            if (cutOffTime) {
              const hoursDiff = startTime.diff(currentTime, "hours");
              const addCuttOffTimeInCurrentTime = currentTime.add(
                cutOffTime * 60 + 15, // cuttOff hours(in minutes) + 15min
                "minutes"
              );
              if (!incidentCenter && hoursDiff < cutOffTime) {
                draftErrors[
                  visit_schedule
                ] = `Please select the visit start time after ${addCuttOffTimeInCurrentTime.format(
                  "hh:mm"
                )} slot.`;
              }
            }
          }

          const duration = calculateDurationHourMinute(dateFrom, dateTo);
          const durationHours = duration.hours + duration.minutes / 60;
          const datesValid = isSTVisit
            ? durationHours >= 0.5 // for speech therapy allow 30mins, 45mins
            : durationHours >= 1 && durationHours <= 24; // regular visits between 1hr to 24hr

          if (!datesValid) {
            draftErrors[visit_schedule] =
              "For Speech Therapy, minimum 30 mins allowed. Regular visits must be between 1 and 24 hrs";
          } else if (!isSTVisit) {
            const remainder = (durationHours * 100) % 100,
              min15 = remainder === 25,
              min45 = remainder === 75;
            if (min15 || min45) {
              const hours = Math.floor(durationHours);
              const err = min15 ? `h or ${hours}.5h` : `.5h or ${hours + 1}h`;
              draftErrors[
                visit_schedule
              ] = `Invalid duration. Please change it to ${hours}${err}`;
            }
          }

          const breakTime = parseFloat(draft[breaks]) || 0;
          if (breakTime >= durationHours) {
            draftErrors[break_error] =
              "Visit break must be less than visit duration";
          }

          // Validate medical escort details
          if (
            isHPCVisit &&
            haveAdl &&
            requestedServices.includes(MEDICAL_ESCORT)
          ) {
            const medicalEscortDetails = draft[medical_escort_details];
            const medEscortErr = getMedicalEscortError(
              draft[visit_schedule],
              medicalEscortDetails,
              this.getRegion()
            );
            if (medEscortErr) {
              draftErrors[requested_services] = medEscortErr;
            }
          }
        }
      } else {
        draftErrors[visit_schedule] = "No start time and end time is selected";
      }

      if (isNurseRequested === UNDEF && isNurseRequired === UNDEF) {
        draftErrors["nurse_error"] = "Nurse requirement not selected";
      }
      if ((isNurseRequired || isNurseRequested) && !reasonForNurse) {
        draftErrors["nurse_error"] = "Nurse requirement not selected";
      }

      if (!isObjEmpty(address)) {
        const required = ["post_code", "country", "street_address"];

        if (isSG) {
          required.push("block_number");
        } else if (isMY) {
          required.push("block_number");
          required.push("district");
          required.push("state");
        } else if (isAU) {
          required.push("street_number");
          required.push("suburb");
          required.push("city");
          required.push("state");
        }
        const { address_list } = this.props.recipientStore?.careRecipient?.co;

        const isAddressExists = address_list.find(
          (row: any) =>
            (row.street_address
              ? address.street_address === row.street_address
              : true) &&
            (row.street_name
              ? address.street_address === row.street_name
              : true) &&
            (row.city ? address.city === row.city : true) &&

            (row.latitude ? address.latitude === row.latitude : true) &&
            (row.longitude ? address.longitude === row.longitude : true) &&
            (row.lat ? address.latitude === row.lat : true) &&
            (row.long ? address.longitude === row.long : true) &&

            (row.post_code ? address.post_code === row.post_code : true) &&
            (row.postcode ? address.post_code === row.postcode : true) &&
            (row.state ? address.state === row.state : true) &&
            (row.street_number
              ? address.street_number === row.street_number
              : true) &&
            (row.suburb ? address.suburb === row.suburb : true) &&
            (row.unit_number ? address.unit_number === row.unit_number : true)
        );

        // Don't accept address if the address data has no lat/long
        let doesAddressHaveLatLong: boolean = true;
        address_list.forEach((addr: any) => {

          const hasLat = addr?.lat && addr?.lat?.length > 0;
          const hasLong = addr?.long && addr?.long?.length > 0;

          const addressIsMissingLatLong = !hasLat || !hasLong;

          if (addressIsMissingLatLong) {
            doesAddressHaveLatLong = false;
          };
        });

        if (!doesAddressHaveLatLong) {
          draftErrors[visit_location_address] = "Latitude and longitude missing from address";
        } else if (!isAddressExists) {
          // this occurs if the selected address in VAL can't be matched to an existing
          // address in the database (meaning the address may have been removed)
          draftErrors[visit_location_address] = "Old address has been deleted";
        };
      }

      // Validate manual transfer (Additional requirements column)
      // For SG/MY all fields are optional
      // Validation below is for Australia only
      //TODO: @abdullah uncomment below in sprint 3
      /*if (isAU && draft[has_manual_transfer]) {
        const haveHelp = draft[manual_transfer_help];
        const error = "Manual Transfer details are missing";

        const haveHoist = draft[have_hoist];
        const coAccept2CPs = draft[co_accept_2_cps];

        if (haveHoist === UNDEF) {
          draftErrors[has_manual_transfer] = error;
        } else if (haveHoist === false) {
          if (haveHelp === UNDEF || (haveHelp === false && !coAccept2CPs)) {
            draftErrors[has_manual_transfer] = error;
          }
        }
      }*/

      if (Object.keys(draftErrors).length > 0) {
        hasError = true;
        draftErrors["index"] = index;
        errors[draft._id] = draftErrors;
      }
    });
    return {
      hasError,
      errors,
      servicesError,
      isHPCVisit,
      isHMVisit,
      isOTVisit,
      isPTVisit,
      isSTVisit,
    };
  };

  handleAllCheck = () => {
    const self = this,
      props = self.props,
      visitDraftStore = props.visitDraftStore;
    const allChecked =
      visitDraftStore.allChecked === false ||
      visitDraftStore.allChecked === UNDEF;
    props.setAllVisitChecked(allChecked, getDraftsType(props));
    this.setState({ allChecked });
  };

  handleVisitCheck = (visit: any) => {
    const self = this,
      props = self.props;
    const checked = visit.selected === false || visit.selected === UNDEF;
    props.setVisitChecked(visit._id, checked, getDraftsType(props));
  };

  // returns all selected visit drafts except given visit
  // while updating visits: return all the visits except given visit (selected or not)
  _allSelected(except?: any) {
    const self = this,
      props = self.props,
      visitDraftStore = props.visitDraftStore;
    const isUpdatingVisits =
      visitDraftStore && visitDraftStore.draftsType === DRAFT_TYPE_UPDATE;
    return getDraftVisits(props).filter(
      (v: any) => v !== except && (isUpdatingVisits || v.selected)
    );
  }
  _copyProperty(visit: any, propName: string, propValue: any, isArray = false) {
    visit[propName] = Object.assign(isArray ? [] : {}, propValue);
  }

  _copyTime(visit: any, propName: string, propValue: any) {
    let visitDateTime = parseDate(visit[visit_schedule][propName]);
    const updatedHours = parseDate(propValue).getHours();
    const updatedMins = parseDate(propValue).getMinutes();

    visitDateTime.setHours(updatedHours);
    visitDateTime.setMinutes(updatedMins);
    visit[visit_schedule][propName] = toISOLocal(visitDateTime);
  }

  _deleteVisit(visit: any) {
    const props = this.props;
    props.deleteVisitDrafts([visit._id], false, getDraftsType(props));
  }

  _update(visits: any[]) {
    const props = this.props;
    props.updateLocalVisitDrafts(visits, getDraftsType(props));
  }

  _onDatesChange = (visit: any, startDate?: Date, endDate?: Date, applyAll?: boolean) => {
    const schedule = visit[visit_schedule];
    // @ts-ignore
    this.isDateUpdated.current = true;
    // Start date should be multiple of 15 mins
    if (startDate) {
      schedule.date_from = toISOLocal(fixVisitStartDate(startDate));
    }

    // validate duration
    // min 30 mins, max 24 hours, duration should be multiple of 15 mins
    schedule.date_to = toISOLocal(
      fixVisitEndDate(
        parseDate(schedule.date_from),
        endDate || parseDate(schedule.date_to)
      )
    );

    if (applyAll) {
      const visits = this._allSelected();
      for (let k = visits.length; k--;) {
        this._copyTime(visits[k], 'date_from', schedule.date_from);
        this._copyTime(visits[k], 'date_to', schedule.date_to);
      }
      visits[0] && this._update(visits);
      this._showSnackbar();
    } else {
      this._update([visit]);
    }

    return {
      startDate: parseDate(schedule.date_from),
      endDate: parseDate(schedule.date_to),
    };
  };

  _visitTimingFlexibilityChange(selected: string, visit?: any, applyAll?: boolean) {
    const updatedPreferredTiming = {
      flexible_visit_timing: selected,
      start_time: '',
      end_time: ''
    };

    visit[co_preferred_timing_obj] = updatedPreferredTiming;

    if (applyAll) {
      const visits = this._allSelected();
      for (let k = visits.length; k--;) {
        this._copyProperty(visits[k], co_preferred_timing_obj, updatedPreferredTiming);
      }
      visits[0] && this._update(visits);
      this._showSnackbar();
    } else {
      this._update([visit]);
    }
  };

  _onPreferredTimeframeChange = (startTime: Date, endTime: Date, visit?: any, applyAll?: boolean) => {
    const preferredTiming = visit[co_preferred_timing_obj];

    if (startTime) {
      preferredTiming.start_time = toISOLocal(fixVisitStartDate(startTime));

      if (preferredTiming.end_time) {
        preferredTiming.end_time = toISOLocal(
          fixVisitEndTime(
            parseDate(preferredTiming.start_time),
            parseDate(preferredTiming.end_time)
          )
        );
      }
    } else {
      preferredTiming.end_time = toISOLocal(fixVisitStartDate(endTime));;
    }

    if (applyAll) {
      const visits = this._allSelected();
      for (let k = visits.length; k--;) {
        this._copyProperty(visits[k], co_preferred_timing_obj, preferredTiming);
      }
      visits[0] && this._update(visits);
      this._showSnackbar();
    } else {
      this._update([visit]);
    }

    return {
      startTime: parseDate(preferredTiming.start_time),
      endTime: parseDate(preferredTiming.end_time)
    };
  };

  _locationChange(
    visit: any,
    updatedLocation: VisitLocationAddress,
    applyAll: boolean
  ) {
    const self = this;
    let visits = [];

    if (applyAll) {
      visits = self._allSelected(visit);
      self._showSnackbar();
    }
    visits.push(visit);

    for (let k = visits.length; k--;) {
      self._copyProperty(visits[k], visit_location_address, updatedLocation);
    }

    self._update(visits);
  }

  _onAdlChange(
    visit: any,
    requestedServices: any[],
    mealRequirements: any[],
    applyAll: boolean
  ) {
    if (!visit) return;
    const self = this,
      servicesSelected = requestedServices && requestedServices[0];

    let visits = [],
      changed = false;

    if (applyAll) {
      visits = self._allSelected(visit);
    }
    visits.push(visit);

    // Medical escort selected
    const medEscSelected =
      requestedServices.includes(MEDICAL_ESCORT) &&
      isObjEmpty(visit[medical_escort_details]);

    for (let k = visits.length; k--;) {
      const kVisit = visits[k];
      if (
        (kVisit[requested_services] || "").toString() !==
        (requestedServices || "").toString() ||
        (kVisit[meal_requirements] || "").toString() !==
        (mealRequirements || "").toString()
      ) {
        changed = true;
      }

      self._copyProperty(kVisit, requested_services, requestedServices, true);
      self._copyProperty(kVisit, meal_requirements, mealRequirements, true);

      // clear therapy selection
      if (servicesSelected) {
        kVisit[home_rehabilitation] = [];
        kVisit[home_medical] = [];
      }

      // clear medical escort details if "Medical Escort" is not in the list
      if (isMEDetailsDisabled(kVisit)) {
        delete kVisit[medical_escort_details];
      }

      const pcpListObj = this._setPreferredCPListForADLorNursingServices(kVisit);
      const thereIsAPreferredCPList = Object.keys(pcpListObj).length > 0;
      if (thereIsAPreferredCPList) {
        kVisit[preferred_cps_list_by_service] = pcpListObj;
      };
    }

    applyAll && changed && self._showSnackbar();
    self._update(visits);

    if (medEscSelected) {
      self._openMedEscortPopup(visit, applyAll);
    }
  }
  _onMedicalChange(
    visit: any,
    requestedMedicals: any[],
    applyAll: boolean
  ) {
    if (!visit) return;
    const self = this,
      servicesSelected = requestedMedicals && requestedMedicals[0];
    let visits = [],
      changed = false;

    if (applyAll) {
      visits = self._allSelected(visit);
    }
    visits.push(visit);

    for (let k = visits.length; k--;) {
      const kVisit = visits[k];
      if (
        (kVisit[medical_conditions] || "").toString() !==
        (requestedMedicals || "").toString()
      ) {
        changed = true;
      }

      self._copyProperty(kVisit, medical_conditions, requestedMedicals, true);

    }

    applyAll && changed && self._showSnackbar();
    self._update(visits);

  }
  _getMedicalList(data: any) {
    return !data || !data.medical_conditions ? [] : data.medical_conditions;
  }
  // List of all Available ADL Services
  _getAdlList(data: any) {
    return !data || !data.services ? [] : data.services;
  }

  _onProceduresChange(visit: any, procedures: any[], applyAll: boolean) {
    if (!visit) return;
    const self = this,
      servicesSelected = procedures && procedures[0];
    let visits = [],
      changed = false;

    if (applyAll) {
      visits = self._allSelected(visit);
    }
    visits.push(visit);
    const newProceduresJson = JSON.stringify(procedures);

    for (let k = visits.length; k--;) {
      if (newProceduresJson !== JSON.stringify(visits[k][nursing_procedure])) {
        changed = true;
      }

      const proceduresCopy = procedures.map((p: any) => Object.assign({}, p));
      self._copyProperty(visits[k], nursing_procedure, proceduresCopy, true);

      // clear therapy selection
      if (servicesSelected) {
        visits[k][home_rehabilitation] = [];
        visits[k][home_medical] = [];
      }

      const pcpListObj = this._setPreferredCPListForADLorNursingServices(visits[k]);
      const thereIsAPreferredCPList = Object.keys(pcpListObj).length > 0;
      if (thereIsAPreferredCPList) {
        visits[k][preferred_cps_list_by_service] = pcpListObj;
      };

      self._updateNurseRequirements(visits[k]);
    }

    applyAll && changed && self._showSnackbar();
    self._update(visits);
  }

  _onHomeMedProceduresChange(
    visit: any,
    medicalProcedures: any[],
    applyAll: boolean
  ) {
    if (!visit) return;
    const self = this;
    let visits = [];
    let changed = false;

    if (applyAll) {
      visits = self._allSelected(visit);
    }
    visits.push(visit);

    const newProceduresJson = JSON.stringify(medicalProcedures);
    let applyCount = 0;

    for (let k = visits.length; k--;) {
      const kVisit = visits[k];

      const homeMedValue = (kVisit[home_medical] || [])[0];
      const isBasicConsultation =
        !isHomeMedicalDisabled(kVisit) && homeMedValue === BASIC_CONSULTATION;

      if (!isBasicConsultation) continue;

      const homeMedDetails = kVisit[home_medical_details] || {};
      const medProcedures = homeMedDetails && homeMedDetails[procedures];

      if (newProceduresJson !== JSON.stringify(medProcedures)) {
        changed = true;
      }

      kVisit[home_medical_details] = homeMedDetails;

      const proceduresCopy = medicalProcedures.map((p: any) =>
        Object.assign({}, p)
      );
      self._copyProperty(homeMedDetails, procedures, proceduresCopy, true);
      applyCount++;
    }

    applyAll && changed && self._showSnackbar(applyCount);
    self._update(visits);
  }

  _nurseRequiredChange(
    visit: any,
    text: string,
    triggerUpdate = true,
    isApplyAll = false
  ) {
    const self = this;
    let required: boolean | undefined, requested: boolean | undefined;

    const haveTherapy = (visit[home_rehabilitation] || [])[0];
    const haveHomeMedical = (visit[home_medical] || [])[0];
    if (haveTherapy || haveHomeMedical) {
      required = false;
      requested = false;
    } else {
      if (text === NURSE_REQUIREMENTS[0]) {
        // not required
        required = false;
      } else if (text === NURSE_REQUIREMENTS[2]) {
        // nurse required
        required = true;
      } else if (text === NURSE_REQUIREMENTS[1]) {
        // nurse requested
        requested = true;
      }
    }

    visit[is_nurse_required] = required;
    visit[is_nurse_requested] = requested;
    visit[reason_for_nurse] = "";
    self._updateNurseRequirements(visit);

    triggerUpdate && self._update([visit]);
    if (isApplyAll && !self._nurseRequiredApplyAll(visit)) {
      !triggerUpdate && self._update([visit]);
    }
  }

  _nurseRequiredApplyAll(visit: any) {
    const self = this;

    const visits = self._allSelected(visit);
    const text = self._getNurseRequirementText(
      visit[is_nurse_requested],
      visit[is_nurse_required]
    );

    let count = 1; // 1 because passed visit's nurse req already applied
    for (let k = visits.length; k--;) {
      const kVisit = visits[k];
      self._nurseRequiredChange(kVisit, text, false);

      if (
        !!kVisit[is_nurse_requested] === !!visit[is_nurse_requested] &&
        !!kVisit[is_nurse_required] === !!visit[is_nurse_required]
      ) {
        count++;
      }
    }

    visits[0] && self._update(visits);
    self._showSnackbar(count);
    return count > 1;
  }

  // Get selected text value for the dropdown
  _getNurseRequirementText(isRequested?: boolean, isRequired?: boolean) {
    if (isRequested === UNDEF && isRequired === UNDEF) return "";
    if (!isRequested && !isRequired) return NURSE_REQUIREMENTS[0]; // not required
    return NURSE_REQUIREMENTS[isRequired ? 2 : 1]; // 2 = nurse required, 1 = nurse requested
  }

  // when nursing procedure is selected
  // set "nurse required"
  _updateNurseRequirements(visit: any) {
    const haveProcedures = !!(visit[nursing_procedure] || [])[0];
    const reason = visit[reason_for_nurse];
    const nursingProcSelected = "Nursing Procedures selected";
    const familyPreferNurse = "Family prefer a nurse";
    let newReason = "";

    if (haveProcedures) {
      visit[is_nurse_required] = true;
      if (visit[is_nurse_requested]) {
        visit[is_nurse_requested] = false;
      }
      if (reason === familyPreferNurse) {
        newReason = nursingProcSelected;
      } else {
        newReason = reason || nursingProcSelected;
      }
    } else if (visit[is_nurse_requested]) {
      newReason = reason || familyPreferNurse;
    }
    // no nursing procedures and nurse_required selected
    else if (visit[is_nurse_required]) {
      newReason = reason === nursingProcSelected ? "" : reason || "";
    }
    // nurse not required
    else {
      newReason = "";
    }

    visit[reason_for_nurse] = newReason;
  }

  _onTherapySelected(
    visit: any,
    therapy: string,
    triggerUpdate = true,
    isApplyAll = false
  ) {
    const self = this;
    if (visit && !isTherapyDisabled(visit)) {
      visit[home_rehabilitation] = therapy ? [therapy] : [];

      // Switch Preferred CPs list to match Home Therapy
      const pcpListObj = this._setPreferredCPListForHomeTherapyServices(visit);
      const thereIsAPreferredCPList = Object.keys(pcpListObj).length > 0;
      if (thereIsAPreferredCPList) {
        visit[preferred_cps_list_by_service] = pcpListObj;
      };

      self._nurseRequiredChange(visit, NURSE_REQUIREMENTS[0], triggerUpdate); // nurse not required
      if (isApplyAll && !self._therapyApplyAll(visit)) {
        !triggerUpdate && self._update([visit]);
      }
      return true;
    }
  }

  _onHomeMedicalSelected(
    visit: any,
    homeMedical: string,
    triggerUpdate = true,
    isApplyAll = false
  ) {
    const self = this;
    if (visit && !isHomeMedicalDisabled(visit)) {
      visit[home_medical] = homeMedical ? [homeMedical] : [];

      //Clear manual transfer when home medical is selected
      visit[has_manual_transfer] = false;
      visit[manual_transfer_help] =
        visit[manual_transfer_help_details] =
        visit[transfer_points] =
        visit[bed] =
        visit[transfer_type] =
        UNDEF;

      // Switch Preferred CPs list to match Home Medical
      const pcpListObj = this._setPreferredCPListForHomeMedicalServices(visit);
      const thereIsAPreferredCPList = Object.keys(pcpListObj).length > 0;
      if (thereIsAPreferredCPList) {
        visit[preferred_cps_list_by_service] = pcpListObj;
      };

      self._nurseRequiredChange(visit, NURSE_REQUIREMENTS[0], triggerUpdate); // nurse not required
      if (isApplyAll && !self._homeMedicalApplyAll(visit)) {
        !triggerUpdate && self._update([visit]);
      }
      return true;
    }
  }

  // try to apply visit's therapy to rest of the selected visits
  _therapyApplyAll = (visit: any) => {
    const self = this;
    const visits = self._allSelected(visit);
    const text = (visit[home_rehabilitation] || [])[0];
    let count = 1; // 1 because passed visit's therapy already applied
    for (let k = visits.length; k--;) {
      count += self._onTherapySelected(visits[k], text, false) ? 1 : 0;
    }
    visits[0] && self._update(visits);
    self._showSnackbar(count);
    return count > 1;
  };

  // try to apply visit's home medical to rest of the selected visits
  _homeMedicalApplyAll(visit: any) {
    const self = this;
    const visits = self._allSelected(visit);
    const text = (visit[home_medical] || [])[0];
    let count = 1; // 1 because passed visit's home medical already applied
    for (let k = visits.length; k--;) {
      count += self._onHomeMedicalSelected(visits[k], text, false) ? 1 : 0;
    }
    visits[0] && self._update(visits);
    self._showSnackbar(count);
    return count > 1;
  }

  _mobilityApplyAll = (visit: any) => {
    const self = this;
    const visits = self._allSelected(visit);
    const mobility = visit[ambulant];

    for (let k = visits.length; k--;) {
      visits[k][ambulant] = mobility;
    }

    visits[0] && self._update(visits);
    self._showSnackbar();
  };

  _visitBreakText(breakValue: any) {
    if (!breakValue || !parseFloat(breakValue)) return VISIT_BREAK_OPTIONS[0];
    return VISIT_BREAK_OPTIONS.find((v) => v.indexOf(breakValue + " ") >= 0);
  }

  _visitBreakChange(visit: any, selectedItem: string) {
    visit[breaks] = (parseFloat(selectedItem) || 0) + "";
    this._update([visit]);
  }

  _onReqCPChange = (visit: any) => (_: any, numCPs: string) => {
    const assigned = visit[assigned_carepros] || [];
    let minCPs = assigned.length > 1 ? assigned.length : 1;

    const haveHoist = visit[have_hoist];
    const haveManualTransferHelp = visit[manual_transfer_help];
    const selectedMedicals = visit[medical_conditions] || [];
    //for AU-> when no hoist and addl. help available
    if (isAU && haveHoist === false && haveManualTransferHelp === false) {
      minCPs = Math.max(2, minCPs);
    }

    const cps = parseInt(numCPs) || minCPs;
    visit[required_cp] = clamp(cps, minCPs, MAX_CPS_FOR_VISIT);
    this._update([visit]);
  };

  _setValue(obj: any, prop: string, value: any) {
    const props = prop.split(".");
    const propsLen = props.length;
    for (let l = 0; l < propsLen; l++) {
      if (l < propsLen - 1) {
        obj[props[l]] = obj[props[l]] || {};
      } else {
        obj[props[l]] = value;
      }
      obj = obj[props[l]];
    }
  }

  // For special_requests_instructions, mobility_instruction, manual_transfer_help_details, transfer_points, cr_notes, cr_fulfilment
  _onPropChange(
    visit: any,
    prop: string,
    text: string,
    isArray = false,
    isApplyAll = false
  ) {
    const self = this;
    const value = !isArray
      ? cleanTextForMobileCompatibility(text)
      : text && (cleanTextForMobileCompatibility(text) || "").split(/, |,/);

    if (isApplyAll) {
      const visits = self._allSelected();
      for (let k = visits.length; k--;) {
        self._setValue(visits[k], prop, value);
      }
      visits[0] && self._update(visits);
      self._showSnackbar();
    } else {
      self._setValue(visit, prop, value);
      self._update([visit]);
    }
  }

  // show snackbar with message "Applied to 3 visits"
  _showSnackbar(appliedCount = 0) {
    const self = this,
      visits = getDraftVisits(self.props);
    const count = appliedCount || self._allSelected().length || 1;
    visits.length > 1 &&
      self.post(MSG_SHOW_SNACKBAR, {
        key: new Date().getTime(),
        message: `Applied to ${count} visit${count > 1 ? "s" : ""}`,
        duration: 2000,
        variant: "success",
      });
  }

  _openAddRequirementsPopup(currentVisit: any, isApplyToAll = false) {

    const payload = {
      visit: Object.assign({}, currentVisit),
      type: DIALOG_TYPE.ADDITIONAL_REQUIREMENTS,
      isUpdate: isApplyToAll,
      anchor: this.addlReqRef.current?.getBoundingClientRect(),
      closeCallbackFrom: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_ADDREQUIREMENTS,
      currentVisit: currentVisit,
      isApplyToAll: isApplyToAll,
    };

    window.postMessage({
      message: MSG_OPEN_VISIT_DIALOG,
      payload
    }, "/");
  }

  _openMedEscortPopup(currentVisit: any, isApplyToAll = false) {

    const payload = {
      visit: Object.assign({}, currentVisit),
      type: DIALOG_TYPE.MEDICAL_ESCORT_DETAILS,
      isUpdate: isApplyToAll,
      anchor: this.medEscRef.current?.getBoundingClientRect(),
      closeCallbackFrom: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_MEDESCORT,
      currentVisit: currentVisit,
      isApplyToAll: isApplyToAll,
    };

    window.postMessage({
      message: MSG_OPEN_VISIT_DIALOG,
      payload
    }, "/");

  };

  _openPatientDeclPopup =
    (currentVisit: any, isApplyToAll = false) =>
      () => {

        const payload = {
          visit: Object.assign({}, currentVisit),
          type: DIALOG_TYPE.PATIENT_DECLARATION,
          isUpdate: isApplyToAll,
          anchor: this.patientDeclRef.current?.getBoundingClientRect(),
          closeCallbackFrom: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PATIENTDECL,
          currentVisit: currentVisit,
          isApplyToAll: isApplyToAll,
        };

        window.postMessage({
          message: MSG_OPEN_VISIT_DIALOG,
          payload
        }, "/");
      };

  _openPreferredCareProsPopUp = (currentVisit: any, isApplyToAll = false) => {


    const payload = {
      visit: Object.assign({}, currentVisit),
      type: DIALOG_TYPE.PREFERRED_CARE_PROS,
      isUpdate: isApplyToAll,
      anchor: this.careProDetailsRef.current?.getBoundingClientRect(),
      closeCallbackFrom: MSG_CLOSE_VISIT_DIALOG_FROM_LISTVIEW_PREFERREDCAREPRO,
      currentVisit: currentVisit,
      isApplyToAll: isApplyToAll,
    };

    window.postMessage({
      message: MSG_OPEN_VISIT_DIALOG,
      payload
    }, "/");
  };

  renderErrorMessage(rowError: any, type: string) {
    if (rowError && rowError[type] && rowError[type].length) {
      const message = rowError[type];
      return (
        <div className='vd-error-message'>{message}</div>
      );
    }
  };

  renderErrorIcon(rowError: any, type: string) {
    if (rowError && rowError[type] && rowError[type].length) {
      return (
        <img
          alt="error"
          src="/warning_red.png"
          className="vd-error-icon-small"
        />
      );
    }
  };

  _errClass(rowError: any, name: string) {
    return rowError && rowError[name] && rowError[name][0]
      ? "vd-error-warning"
      : "";
  }

  // return dash for empty sections (readonly state while updating visits)
  _dashIfEmpty(visit?: any, prop?: string) {
    return (
      (!visit || !prop || !visit[prop] || !visit[prop].length) && (
        <span className="vdl-dash">-</span>
      )
    );
  }

  _onMemoUpload =
    (visit: Visit, isApplyAll = false) =>
      (files: UploadData[]) => {
        const self = this;

        const therapyDetails = visit[therapy_details] || {};

        const displayUrls = files.map((f) => f.displayUrl);
        const s3Urls = files.map((f) => f.s3Url);
        const existingMemo = therapyDetails[doctor_memo] || [];
        const existingBlobs = therapyDetails[blob_urls] || [];

        therapyDetails[doctor_memo] = existingMemo.concat(s3Urls);
        therapyDetails[blob_urls] = existingBlobs.concat(displayUrls);

        visit[therapy_details] = therapyDetails;

        isApplyAll && self._therapyDetailsApplyAll(visit, therapyDetails);
        self._update([visit]);
      };
  _onMemoDelete =
    (visit: Visit, isApplyAll = false) =>
      (index: number) => {
        const self = this;
        const therapyDetails = visit[therapy_details] || {};

        therapyDetails[doctor_memo]?.splice(index, 1);
        therapyDetails[blob_urls]?.splice(index, 1);
        therapyDetails[blob_urls] = therapyDetails[blob_urls]?.slice();

        isApplyAll && self._therapyDetailsApplyAll(visit, therapyDetails);
        self._update([visit]);
      };
  _onMemoNotAvailable =
    (visit: Visit, isApplyAll = false) =>
      () => {
        const self = this;
        const therapyDetails = visit[therapy_details] || {};

        const have = therapyDetails[doctor_memo_available];
        therapyDetails[doctor_memo_available] = have === UNDEF ? false : !have;

        visit[therapy_details] = therapyDetails;
        isApplyAll && self._therapyDetailsApplyAll(visit, therapyDetails);

        self._update([visit]);
      };

  _therapyDetailsApplyAll(visit: Visit, details: TherapyDetails) {
    const self = this;
    const visits = self._allSelected(visit);
    for (let i = visits.length; i--;) {
      visits[i][therapy_details] = JSON.parse(JSON.stringify(details));
    }
  }

  // CTRL + C copy to all visits
  _onKeyPress(e: any, visit: any, prop: string, value?: string) {
    if (e.key === "c" && e.ctrlKey) {
      this._onPropChange(visit, prop, value || visit[prop], false, true);
    }
  };

  _renderRow(
    visit: any,
    hasBreaks = false,
    isUpdatingVisits = false,
    isPendingPaymentDraft = false,
    isMedicalConditionsFeatureEnabled: boolean
  ) {
    const self = this,
      props = self.props,
      recipientStore = props.recipientStore;
    const visitDraftStore = props.visitDraftStore;
    const details = props.recipientStore && props.recipientStore.careRecipient;
    const crInfo = details && details.cr;
    const selectedMedicals = visit[medical_conditions] || [];
    let selected = visit.selected !== UNDEF ? visit.selected : false;
    let rowError = self.state.errors && self.state.errors[visit._id];
    const states = recipientStore && recipientStore.states;
    //const locationFields = recipientStore && recipientStore.locationFields;

    //const readOnly = isUpdatingVisits;
    //const readOnlyAttrib = readOnly ? '' : UNDEF;

    const haveAdditionalRequirements =
      visit[has_manual_transfer] || visit[require_vital_sign];

    const selectedMobility = !visit[ambulant]
      ? UNDEF
      : MOBILITY_TYPES.find((type: string) => type.startsWith(visit[ambulant]));

    const selectedAdls = visit[requested_services] || [];
    const homeMedicalDetails = visit[home_medical_details] || {};
    const selectedHomeMedProcedures = homeMedicalDetails[procedures] || [];
    const isHomeMedDisabled = isHomeMedicalDisabled(visit);
    const homeMedValue = (visit[home_medical] || [])[0];
    const isBasicConsultation =
      !isHomeMedDisabled && homeMedValue === BASIC_CONSULTATION;

    const therapyList = (visitDraftStore && visitDraftStore.therapy) || [];
    const therapyDisabled = isTherapyDisabled(visit);
    const therapyType = (visit[home_rehabilitation] || [])[0];
    const havePatientDecl = havePatientDeclaration(visit);
    const therapyDetails = visit[therapy_details] || {};
    if (therapyDetails && !therapyDetails[blob_urls]) {
      // create a copy of doctor memo
      therapyDetails[blob_urls] = (therapyDetails[doctor_memo] || []).slice();
    }

    const procedureList =
      visitDraftStore && visitDraftStore.available_procedures;
    const selectedProcedures = visit[nursing_procedure];

    const isNurseRequested = visit[is_nurse_requested];
    const isNurseRequired = visit[is_nurse_required];

    const defaultApplyAll = isUpdatingVisits || isPendingPaymentDraft;
    const doneBtnText = defaultApplyAll ? "Apply to all visits" : UNDEF;

    const displaySelectPreferredCPs = true;

    return (
      <div key={visit._id} className={rowError ? "vd-error-warning" : ""}>
        {/* First column checkbox and delete */}
        <PureComp watchList={[visit, rowError, selected, defaultApplyAll]}>
          <div
            // ref={visit._id}
            style={{
              position: "sticky",
              zIndex: 2,
              background: rowError ? "#FFF5F7" : "#fff",
              left: "0",
              padding: "12px 10px",
            }}
          >
            <Checkbox
              style={{ display: "block" }}
              checked={selected}
              onChange={() => self.handleVisitCheck(visit)}
              className="ha-checkbox"
            />
            {!defaultApplyAll && (
              <input
                className="vd-delete"
                type="image"
                alt=""
                src="/delete.png"
                onClick={() => self._deleteVisit(visit)}
              />
            )}
          </div>
        </PureComp>

        {/* Date & Time */}
        <div className={self._errClass(rowError, visit_schedule)}>
          {self.renderErrorIcon(rowError, visit_schedule)}
          <PureComp
            watchList={[
              visit,
              visit[visit_schedule].date_from,
              visit[visit_schedule].date_to,
            ]}
          >
            <DateTimeDisplay
              vertical
              dontAnimate
              dontAllowPastDates
              boldToday
              startDate={
                isUpdatingVisits && this.isDateUpdated.current !== true
                  ? convertToDestTZ(
                    parseDate(visit[visit_schedule].date_from),
                    this.getRegion()
                  )
                  : parseDate(visit[visit_schedule].date_from)
              }
              endDate={
                isUpdatingVisits && this.isDateUpdated.current !== true
                  ? convertToDestTZ(
                    parseDate(visit[visit_schedule].date_to),
                    this.getRegion()
                  )
                  : parseDate(visit[visit_schedule].date_to)
              }
              onChange={(d1: Date, d2: Date) =>
                self._onDatesChange(visit, d1, d2, true)
              }
            />
          </PureComp>
        </div>

        {/* Visit Timing Flexibility */}
        <div className={self._errClass(rowError, co_preferred_timing_obj)}>
          {self.renderErrorIcon(rowError, co_preferred_timing_obj)}
          <PureComp
            watchList={[
              visit,
              visit[co_preferred_timing_obj],
              visit[co_preferred_timing_obj].start_time,
              visit[co_preferred_timing_obj].end_time,
            ]}
          >
            <div className="vdl-flexible-visit-timing">
              <FlexibleVisitTiming
                startDate={
                  isUpdatingVisits && this.isDateUpdated.current !== true
                    ? convertToDestTZ(
                      parseDate(visit[visit_schedule].date_from),
                      this.getRegion()
                    )
                    : parseDate(visit[visit_schedule].date_from)
                }
                endDate={
                  isUpdatingVisits && this.isDateUpdated.current !== true
                    ? convertToDestTZ(
                      parseDate(visit[visit_schedule].date_to),
                      this.getRegion()
                    )
                    : parseDate(visit[visit_schedule].date_to)
                }
                startTime={
                  visit[co_preferred_timing_obj]?.start_time
                    ? parseDate(visit[co_preferred_timing_obj].start_time)
                    : ''
                }
                endTime={
                  visit[co_preferred_timing_obj]?.end_time
                    ? parseDate(visit[co_preferred_timing_obj].end_time)
                    : ''
                }
                visitTimingFlexibility={visit[co_preferred_timing_obj]?.flexible_visit_timing}
                onChange={(selected: string) =>
                  self._visitTimingFlexibilityChange(selected, visit, true)
                }
                handleTimeChange={(start: Date, end: Date) => {
                  self._onPreferredTimeframeChange(start, end, visit, true);
                }}
                hideTooltip={true}
              />
            </div>
          </PureComp>
        </div>

        {/* Location */}
        <div className={self._errClass(rowError, visit_location_address)}>
          {self.renderErrorIcon(rowError, visit_location_address)}
          {self.renderErrorMessage(rowError, visit_location_address)}
          <PureComp
            watchList={[
              visit,
              defaultApplyAll,
              states,
              getLocationText(visit[visit_location_address]),
            ]}
          >
            <LocationDropdown
              // @ts-ignore
              showAsPopup
              visit={visit}
              location={visit[visit_location_address]}
              onChange={(loc: VisitLocationAddress, isApplyAll: boolean) =>
                self._locationChange(
                  visit,
                  loc,
                  isApplyAll || defaultApplyAll
                )
              }
              fieldsStyle={s_fs13}
            />
          </PureComp>
        </div>

        {/* Services */}
        {/* ADL Services & Nursing Procedures & Nurse Requirement & Home Therapy & Home Medical*/}
        <div className={self._errClass(rowError, requested_services)}>
          <span>ADL Services</span>
          <div className="sub-title-spacer " />
          {self.renderErrorIcon(rowError, requested_services)}
          {/*defaultApplyAll && self._dashIfEmpty(visit, requested_services)*/}
          <AdlServices
            showApplyAll={!defaultApplyAll}
            className="vd-services-container"
            tdClassName="vd-service"
            tdInputClassName="vd-add-adl"
            doneBtnText={doneBtnText}
            adlList={self._getAdlList(visitDraftStore)}
            requested_services={selectedAdls}
            meal_requirements={visit[meal_requirements]}
            onAdlChange={(req: any[], meal: any[], isApplyAll: boolean) =>
              self._onAdlChange(visit, req, meal, isApplyAll || defaultApplyAll)
            }
          >
            {selectedAdls.includes(COMPANIONSHIP) && (
              <>
                <Txt m mv={6} ml={6}>
                  Companionship Description
                </Txt>
                <InputField
                  type="text"
                  className="vd-specific-instructions"
                  inpClassName="thin-scrollbar"
                  width="100%"
                  maxWidth="100%"
                  multiLine
                  noAutoSelect
                  lineHeight={16}
                  maxLines={6}
                  blurOnTabKey
                  placeholder="e.g. She enjoys music, dancing and calligraphy"
                  onTextChange={(_e: any, t: string) =>
                    self._onPropChange(visit, companionship_description, t)
                  }
                  text={visit[companionship_description]}
                  onKeyPress={(_: any, _b: any, e: any) =>
                    self._onKeyPress(e, visit, companionship_description)
                  }
                  onBlur={
                    !defaultApplyAll
                      ? UNDEF
                      : (c: any) =>
                        c.isChanged() &&
                        self._onPropChange(
                          visit,
                          companionship_description,
                          visit[companionship_description],
                          false,
                          true
                        )
                  }
                />
                <Div height={7} />
              </>
            )}

            {visit[medical_escort_details] &&
              selectedAdls.includes(MEDICAL_ESCORT) && (
                <Div
                  minW={200}
                  className="nvd-me-desc v"
                  onClick={(_e: any) =>
                    self._openMedEscortPopup(visit, defaultApplyAll)
                  }
                >
                  <Txt m mv={6} ml={6}>
                    Medical Escort Details
                  </Txt>
                  <span className="nvd-me-details">
                    {getMedicalEscortDetails(visit, this.getRegion())}
                  </span>
                  <Div height={7} />
                </Div>
              )}
          </AdlServices>

          {/* Nursing Procedures */}
          <div className={self._errClass(rowError, nursing_procedure)}>
            <span>Nursing Procedures</span>
            <div className="sub-title-spacer " />
            {self.renderErrorIcon(rowError, nursing_procedure)}
            <PureComp
              watchList={[
                visit,
                defaultApplyAll,
                procedureList,
                JSON.stringify(selectedProcedures),
              ]}
            >
              <NursingProcedures
                showApplyAll={!defaultApplyAll}
                className="vd-services-container"
                tdClassName="vd-service"
                tdInputClassName="vd-proc-input"
                doneBtnText={doneBtnText}
                available_procedures={procedureList}
                selectedProcedures={selectedProcedures}
                style={s_w100}
                onProceduresChange={(procedures: any[], isApplyAll: boolean) =>
                  self._onProceduresChange(
                    visit,
                    procedures,
                    isApplyAll || defaultApplyAll
                  )
                }
              />
            </PureComp>
          </div>

          {/* Nurse requirement */}
          <div className={self._errClass(rowError, nurse_error)}>
            <span>Nurse Requirement</span>
            <div className="sub-title-spacer " />
            {self.renderErrorIcon(rowError, nurse_error)}
            <PureComp
              watchList={[
                visit,
                defaultApplyAll,
                isNurseRequested,
                isNurseRequired,
                visit[reason_for_nurse],
                (visit[nursing_procedure] || [])[0],
              ]}
            >
              <TextDropdown
                multiSelection={!defaultApplyAll}
                noFilter
                items={NURSE_REQUIREMENTS}
                width="100%"
                maxWidth="100%"
                popupWidth={defaultApplyAll ? UNDEF : "270px"}
                placeholder="Nurse requirements"
                className="vd-service"
                inputClassName="vd-inp-class"
                doneBtnText={doneBtnText}
                disabled={!!(visit[nursing_procedure] || [])[0]}
                selectedItem={self._getNurseRequirementText(
                  isNurseRequested,
                  isNurseRequired
                )}
                selectedItems={[
                  self._getNurseRequirementText(
                    isNurseRequested,
                    isNurseRequired
                  ),
                ]}
                onChange={(_: any, selectedItem: string) =>
                  self._nurseRequiredChange(
                    visit,
                    selectedItem,
                    !defaultApplyAll,
                    defaultApplyAll
                  )
                }
                onApplyAll={
                  defaultApplyAll
                    ? UNDEF
                    : (_: any) => self._nurseRequiredApplyAll(visit)
                }
              />
              <Div height={1} />
              <InputField
                type="text"
                className="vd-specific-instructions"
                inpClassName="thin-scrollbar"
                width="100%"
                maxWidth="100%"
                noAutoSelect
                multiLine
                maxLines={6}
                lineHeight={15}
                blurOnTabKey
                placeholder="Reason"
                onKeyPress={(_: any, _b: any, e: any) =>
                  self._onKeyPress(e, visit, reason_for_nurse)
                }
                hidden={!isNurseRequired && !isNurseRequested}
                onTextChange={(_e: any, t: string) =>
                  self._onPropChange(visit, reason_for_nurse, t)
                }
                onBlur={
                  !defaultApplyAll
                    ? UNDEF
                    : (c: any) =>
                      c.isChanged() &&
                      self._onPropChange(
                        visit,
                        reason_for_nurse,
                        visit[reason_for_nurse],
                        false,
                        true
                      )
                }
                text={visit[reason_for_nurse]}
              />
            </PureComp>
          </div>


          {/* Therapy */}
          <div className={self._errClass(rowError, home_rehabilitation)}>
            <span>Home Therapy</span>
            <div className="sub-title-spacer " />
            {self.renderErrorIcon(rowError, home_rehabilitation)}

            {!therapyDisabled && (
              <PureComp
                watchList={[
                  visit,
                  defaultApplyAll,
                  therapyType,
                  therapyList,
                  JSON.stringify(therapyDetails),
                ]}
              >
                <TextDropdown
                  multiSelection={!defaultApplyAll}
                  noFilter
                  className="vd-service"
                  dropdownColor={c4A4A4A}
                  placeholder="Home Therapy"
                  inputClassName="vd-inp-class"
                  popupWidth={defaultApplyAll ? UNDEF : "270px"}
                  width="100%"
                  maxWidth="100%"
                  multiLine
                  doneBtnText={doneBtnText}
                  selectedItem={therapyType}
                  selectedItems={[therapyType]}
                  items={therapyList}
                  onChange={(_: any, selectedItem: string) =>
                    self._onTherapySelected(
                      visit,
                      selectedItem,
                      !defaultApplyAll,
                      defaultApplyAll
                    )
                  }
                  onApplyAll={
                    defaultApplyAll ? UNDEF : () => self._therapyApplyAll(visit)
                  }
                />

                {/* Show doctor memo section for physiotherapy and speech therapy */}
                {(therapyType === PHYSIOTHERAPY ||
                  therapyType === SPEECH_THERAPY) && (
                    <DoctorsMemo
                      compact
                      coId={props.coId || props.vwoId || ""}
                      displayUrls={therapyDetails[blob_urls] || []}
                      memoAvailable={therapyDetails[doctor_memo_available]}
                      onUploadSuccess={self._onMemoUpload(visit, defaultApplyAll)}
                      onDelete={self._onMemoDelete(visit, defaultApplyAll)}
                      onNotAvailable={self._onMemoNotAvailable(
                        visit,
                        defaultApplyAll
                      )}
                      mt={3}
                      ml={8}
                      mb={7}
                    />
                  )}

                {!therapyDisabled && therapyType === OCCUPATIONAL_THERAPY && (
                  <Div pb={7}>
                    <InputField
                      type="text"
                      className="vd-specific-instructions"
                      inpClassName="thin-scrollbar"
                      width="100%"
                      maxWidth="100%"
                      multiLine
                      noAutoSelect
                      lineHeight={16}
                      maxLines={6}
                      blurOnTabKey
                      placeholder="What is the Care Owner's expected outcome?"
                      onKeyPress={(_: any, _b: any, e: any) =>
                        self._onKeyPress(
                          e,
                          visit,
                          therapy_details + "." + expected_outcome,
                          therapyDetails[expected_outcome]
                        )
                      }
                      onTextChange={(_: any, t: string) =>
                        self._onPropChange(
                          visit,
                          therapy_details + "." + expected_outcome,
                          t
                        )
                      }
                      onBlur={
                        !defaultApplyAll
                          ? UNDEF
                          : (c: any) =>
                            c.isChanged() &&
                            self._onPropChange(
                              visit,
                              therapy_details + "." + expected_outcome,
                              therapyDetails[expected_outcome],
                              false,
                              true
                            )
                      }
                      text={therapyDetails[expected_outcome]}
                    />
                  </Div>
                )}
              </PureComp>
            )}

            {therapyDisabled && (
              <div className="vd-therapy-disabled h center">
                Select Therapy as a standalone service
              </div>
            )}
          </div>

          {/* Home Medical */}
          <div className={self._errClass(rowError, home_medical)}>
            <span>Home Medical</span>
            <div className="sub-title-spacer " />
            {self.renderErrorIcon(rowError, home_medical)}

            {!isHomeMedDisabled && (
              <TextDropdown
                multiSelection={!defaultApplyAll}
                noFilter
                className="vd-service"
                dropdownColor={c4A4A4A}
                placeholder="Home Medical"
                inputClassName="vd-inp-class"
                popupWidth={defaultApplyAll ? UNDEF : "270px"}
                width="100%"
                maxWidth="100%"
                multiLine
                doneBtnText={doneBtnText}
                selectedItem={homeMedValue}
                selectedItems={[homeMedValue]}
                items={(visitDraftStore && visitDraftStore[home_medical]) || []}
                onChange={(_: any, selectedItem: string) =>
                  self._onHomeMedicalSelected(
                    visit,
                    selectedItem,
                    !defaultApplyAll,
                    defaultApplyAll
                  )
                }
                onApplyAll={
                  defaultApplyAll
                    ? UNDEF
                    : (_: any) => self._homeMedicalApplyAll(visit)
                }
              />
            )}

            <div
              className={`vd-therapy-disabled h center ${!isHomeMedDisabled ? "gone" : ""
                }`}
            >
              Select Home Medical as a standalone service
            </div>
          </div>

        </div>

        {/* Medical Procedures */}
        <div className={self._errClass(rowError, procedures)}>
          {self.renderErrorIcon(rowError, procedures)}

          {isBasicConsultation && (
            <NursingProcedures
              showApplyAll={!defaultApplyAll}
              className="vd-services-container"
              tdClassName="vd-service"
              tdInputClassName="vd-proc-input"
              homeMedical
              placeholder="Select medical procedures"
              doneBtnText={doneBtnText}
              available_procedures={
                visitDraftStore && visitDraftStore.home_medical_procedures
              }
              selectedProcedures={selectedHomeMedProcedures}
              style={s_w100}
              onProceduresChange={(procedures: any[], isApplyAll: boolean) =>
                self._onHomeMedProceduresChange(
                  visit,
                  procedures,
                  isApplyAll || defaultApplyAll
                )
              }
            />
          )}

          {!isBasicConsultation && (
            <div className="vd-therapy-disabled h center">
              Applicable for Home Medical services only
            </div>
          )}
        </div>

        {/* Patient Declaration */}
        <Div
          className={self._errClass(rowError, home_medical_details)}
          onClick={
            !isBasicConsultation
              ? UNDEF
              : self._openPatientDeclPopup(visit, defaultApplyAll)
          }
          pointer={isBasicConsultation}
          p={isBasicConsultation ? 12 : 5}
          minW={isBasicConsultation && havePatientDecl ? 181 : UNDEF}
        >
          {self.renderErrorIcon(rowError, home_medical_details)}

          {isBasicConsultation && (
            <PatientDeclarationDisplay visit={visit} className="vdl-pdd v" />
          )}

          {!isBasicConsultation && (
            <div className="vd-therapy-disabled h center">
              Applicable for Home Medical services only
            </div>
          )}
        </Div>

        {/* Mobility */}
        <div className={self._errClass(rowError, ambulant)}>
          {self.renderErrorIcon(rowError, ambulant)}
          <PureComp
            watchList={[
              visit,
              defaultApplyAll,
              selectedMobility,
              visit[ambulant],
              visit[mobility_instruction],
            ]}
          >
            <TextDropdown
              width="100%"
              maxWidth="100%"
              popupWidth={defaultApplyAll ? UNDEF : "270px"}
              className="vd-service"
              inputClassName="vd-inp-class"
              multiLine
              noFilter
              multiSelection={!defaultApplyAll}
              doneBtnText={doneBtnText}
              items={MOBILITY_TYPES}
              selectedItem={selectedMobility}
              selectedItems={selectedMobility ? [selectedMobility] : UNDEF}
              placeholder="Mobility Level"
              onChange={(_: any, t: string) =>
                self._onPropChange(
                  visit,
                  ambulant,
                  t && t.split(":")[0],
                  false,
                  defaultApplyAll
                )
              }
              onApplyAll={
                defaultApplyAll ? UNDEF : () => self._mobilityApplyAll(visit)
              }
            />
            <Div height={1} />

            {!!visit[ambulant] && (
              <InputField
                type="text"
                className="vd-specific-instructions"
                inpClassName="thin-scrollbar"
                width="100%"
                maxWidth="100%"
                multiLine
                noAutoSelect
                lineHeight={15}
                maxLines={6}
                blurOnTabKey
                onKeyPress={(_: any, _b: any, e: any) =>
                  self._onKeyPress(e, visit, mobility_instruction)
                }
                placeholder="Are there any specific mobility instructions?"
                onTextChange={(_: any, t: string) =>
                  self._onPropChange(visit, mobility_instruction, t)
                }
                onBlur={
                  !defaultApplyAll
                    ? UNDEF
                    : (c: any) =>
                      c.isChanged() &&
                      self._onPropChange(
                        visit,
                        mobility_instruction,
                        visit[mobility_instruction],
                        false,
                        true
                      )
                }
                text={visit[mobility_instruction]}
              />
            )}
          </PureComp>
        </div>

        {/* Special Instructions */}
        <div>
          <PureComp
            watchList={[
              visit,
              visit[special_requests_instructions],
              defaultApplyAll,
            ]}
          >
            <InputField
              type="text"
              className="vd-input-field"
              inpClassName="thin-scrollbar"
              width="100%"
              maxWidth="100%"
              lineHeight={15}
              maxLines={20}
              multiLine
              noAutoSelect
              blurOnTabKey
              onKeyPress={(_: any, _b: any, e: any) =>
                self._onKeyPress(e, visit, special_requests_instructions)
              }
              placeholder="Special Instructions"
              onTextChange={(_: any, t: string) =>
                self._onPropChange(visit, special_requests_instructions, t)
              }
              onBlur={
                !defaultApplyAll
                  ? UNDEF
                  : (c: any) =>
                    c.isChanged() &&
                    self._onPropChange(
                      visit,
                      special_requests_instructions,
                      visit[special_requests_instructions],
                      false,
                      true
                    )
              }
              text={visit[special_requests_instructions]}
            />
          </PureComp>
        </div>

        {isMedicalConditionsFeatureEnabled
          ? <div className={self._errClass(rowError, medical_conditions)}>

            {self.renderErrorIcon(rowError, medical_conditions)}
            <MedicalServices
              showApplyAll={!defaultApplyAll}
              className="vd-services-container medical-condition-container"
              tdClassName="vd-service"
              tdInputClassName="vd-add-adl"
              doneBtnText={doneBtnText}
              medicalList={self._getMedicalList(crInfo)}
              medical_conditions={selectedMedicals}
              onMedicalChange={(req: any[], isApplyAll: boolean) =>
                self._onMedicalChange(visit, req, isApplyAll || defaultApplyAll)
              }
              value={visit[preferred_cps_option]}
              hidemedical={true}
            >
            </MedicalServices>
          </div>
          : null}

        {/* Add'l Requirements */}
        <Div
          onClick={() => self._openAddRequirementsPopup(visit, defaultApplyAll)}
          pointer
          p={haveAdditionalRequirements ? 12 : 5}
          className={self._errClass(rowError, has_manual_transfer)}
        >
          {self.renderErrorIcon(rowError, has_manual_transfer)}
          <AdditionalRequirementsInfo
            visit={visit}
            rootClassName="vd-services-container"
            bulletClassName="vd-bullet"
          />
          {rowError?.has_manual_transfer
            && <span className="vd-cell-error">
              {rowError[has_manual_transfer]}
            </span>}

        </Div>

        {/* Break */}
        {hasBreaks && (
          <div className={self._errClass(rowError, break_error)}>
            {self.renderErrorIcon(rowError, break_error)}
            <PureComp watchList={[visit, visit[breaks]]}>
              <TextDropdown
                width="100%"
                maxWidth="100%"
                className="vd-service"
                inputClassName="vd-inp-class"
                items={VISIT_BREAK_OPTIONS}
                selectedItem={self._visitBreakText(visit[breaks])}
                onChange={(_: any, selectedItem: string) =>
                  self._visitBreakChange(visit, selectedItem)
                }
              />
            </PureComp>
          </div>
        )}

        {/* # of CPs */}
        <div>
          <span>Number of CPs required</span>
          <PureComp watchList={[visit, visit[required_cp]]}>
            <InputField
              type="number"
              className="vd-input-field"
              width="100%"
              maxWidth="100%"
              lineHeight={15}
              placeholder="#"
              onTextChange={self._onReqCPChange(visit)}
              text={visit[required_cp]}
            />
          </PureComp>
          {displaySelectPreferredCPs ?
            <SelectPreferredCarePros
              onClickButton={() => self._openPreferredCareProsPopUp(visit, defaultApplyAll)}
              showSelectPreferredCarePros={visit[preferred_cps]}
              careProsList={visit[preferred_cps_list_by_service]}
              thereAreHomePersonalCareServicesSelected={visit[requested_services]?.length > 0 || visit[nursing_procedure]?.length > 0}
              thereAreHomeTherapyServicesSelected={visit[home_rehabilitation]?.length > 0}
              thereAreHomeMedicalServicesSelected={visit[home_medical]?.length > 0}
              isReadOnlyMode={false}
              hideTheButton={true}
            />
            : null}
          <HardSoftPreferenceForListView
            value={visit[preferred_cps_option]}
            visit={visit}
            onChangeOfServices={(updatedVisit) => self._update([{ ...updatedVisit }])}
            designationObj={visit[hard_soft_value_designation]}
            careProsList={visit[preferred_cps_list_by_service]}
            thereAreHomePersonalCareServicesSelected={visit?.requested_services?.length > 0 || visit?.nursing_procedure?.length > 0}
            thereAreHomeTherapyServicesSelected={visit?.home_rehabilitation?.length > 0}
            thereAreHomeMedicalServicesSelected={visit?.home_medical?.length > 0}
          />
        </div>

        {/* CR Notes */}
        <div>
          <span>CR Notes</span>
          <PureComp
            watchList={[visit, visit[internal_ops_cr_note], defaultApplyAll]}
          >
            <InputField
              type="text"
              className="vd-input-field"
              inpClassName="thin-scrollbar"
              width="100%"
              maxWidth="100%"
              lineHeight={15}
              maxLines={20}
              multiLine
              noAutoSelect
              blurOnTabKey
              placeholder=""
              onKeyPress={(_: any, _b: any, e: any) =>
                self._onKeyPress(e, visit, internal_ops_cr_note)
              }
              onTextChange={(_: any, t: string) =>
                self._onPropChange(visit, internal_ops_cr_note, t)
              }
              onBlur={
                !defaultApplyAll
                  ? UNDEF
                  : (c: any) =>
                    c.isChanged() &&
                    self._onPropChange(
                      visit,
                      internal_ops_cr_note,
                      visit[internal_ops_cr_note],
                      false,
                      true
                    )
              }
              text={visit[internal_ops_cr_note]}
            />
          </PureComp>

          <div className="spacer" />

          {/* Fulfillment Notes */}
          <span>Fulfillment Notes</span>
          {/* Fulfillment Notes */}
          <PureComp watchList={[visit, visit[internal_ops_fulfillment_note]]}>
            <InputField
              type="text"
              className="vd-input-field"
              inpClassName="thin-scrollbar"
              width="100%"
              maxWidth="100%"
              lineHeight={22}
              maxLines={20}
              multiLine
              noAutoSelect
              blurOnTabKey
              placeholder=""
              onKeyPress={(_: any, _b: any, e: any) =>
                self._onKeyPress(e, visit, internal_ops_fulfillment_note)
              }
              onTextChange={(_: any, t: string) =>
                self._onPropChange(visit, internal_ops_fulfillment_note, t)
              }
              text={visit[internal_ops_fulfillment_note]}
            />
          </PureComp>
        </div>
      </div>
    );
  }

  removeTemporaryKeyForHardSoftPreference = () => {
    const self = this;
    const props = self.props;
    const visits = getDraftVisits(props);

    // We are just deleting a key here that is used locally, and not intended for the API.

    let visitObjectsRequiredCleaning = false;

    const updatedVisits = visits.map((visit: any) => {
      if (Object.hasOwn(visit, hard_soft_value_designation)) {
        visitObjectsRequiredCleaning = true;
        delete visit[hard_soft_value_designation];
      };

      return visit;
    });

    if (visitObjectsRequiredCleaning) {
      self._update(updatedVisits)
    };
  };

  continueToPricing = () => {
    const self = this,
      props = self.props;
    const details = props.recipientStore && props.recipientStore.careRecipient;
    const crInfo = details && details.cr;

    const {
      hasError,
      errors,
      servicesError,
      isHPCVisit,
      isHMVisit,
      isOTVisit,
      isPTVisit,
      isSTVisit,
    } = self.checkDraftForErrors();

    let showError = false;
    let errMsg = "";

    // show a dialog when ca report not published
    if (!isB2b(crInfo)) {
      if (isHPCVisit && (!crInfo || !crInfo.care_assessment_published)) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because the CA report has not been published yet. Please save as drafts in the meantime.";
      } else if (isHPCVisit && !crInfo.hpc_ready) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because CR profile for Home Personal Care & Nursing is not completed yet. Please save as drafts in the meantime.";
      } else if (isHMVisit && !crInfo.hm_ready) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because CR profile for Home Medical is not completed yet. Please save as drafts in the meantime.";
      } else if (isOTVisit && !crInfo.ot_ready) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because CR profile for Occupational Therapy is not completed yet. Please save as drafts in the meantime.";
      } else if (isPTVisit && !crInfo.pt_ready) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because CR profile for Physiotherapy is not completed yet. Please save as drafts in the meantime.";
      } else if (isSTVisit && !crInfo.st_ready) {
        showError = true;
        errMsg =
          "Visits cannot be scheduled because CR profile for Speech Therapy is not completed yet. Please save as drafts in the meantime.";
      }
    }

    if (showError) {
      self.setState({
        _showNoCADialog: true,
        _errDlgMsg: errMsg,
      });
      return;
    }

    if (hasError || servicesError) {
      self.setState({ errors, servicesError });
    } /*else if (servicesError) {
      self.post(MSG_SHOW_SNACKBAR, {
        key: "service-error",
        message:
          "Different service types can't be selected for selected visits",
        duration: 2000,
        variant: "error",
      });
    }*/ else {

      self.removeTemporaryKeyForHardSoftPreference();

      self.setState({
        pricingEngineOpen: true,
        errors: {},
        _reviewUpdateData: UNDEF,
      });
    }
  };

  backToUpdateVisit = (visitID: any) => {
    const crID = this.props.recipientStore && this.props.recipientStore.careRecipient.cr._id;
    const co = this.props.recipientStore && this.props.recipientStore.careRecipient.cr.care_owners[0];
    const coID = co.user_id;
    const url = `/cr/${crID}/${coID}?action=update&visit_ids=${visitID}`;
    window.open(url, "_self");
  }

  nextPage = () => {
    let self = this;
    let { currentPage } = self.state;
    let totalPage = self.props.totalPage || 1;
    if (currentPage < totalPage) {
      currentPage += 1;
      self.setState({ currentPage });
    }
  };

  previousPage = () => {
    let self = this;
    let { currentPage } = self.state;
    if (currentPage > 1) {
      currentPage -= 1;
      self.setState({ currentPage });
    }
  };

  render() {
    const self = this,
      state = self.state,
      props = self.props,
      visitDraftStore = props.visitDraftStore;
    const draftType = visitDraftStore.draftsType;
    const isUpdatingVisits = draftType === DRAFT_TYPE_UPDATE;
    const isPendingPaymentDraft = draftType === DRAFT_TYPE_PENDING_PAYMENT;
    const visits = getDraftVisits(props);

    const haveVisits = visits && visits[0];

    const details = props.recipientStore && props.recipientStore.careRecipient;
    const crInfo = details && details.cr;
    const hasBreaks = (crInfo || {}).has_breaks;
    const totalPage = props.totalPage || 1;
    const currentPage = self.state.currentPage;
    const isSavingDrafts = visitDraftStore.savingDrafts;

    const isStaging = process.env.REACT_APP_API_URL?.includes('testing');

    let isMedicalConditionsFeatureEnabled = isSG || isMY ? true : false;
    isMedicalConditionsFeatureEnabled = isStaging ? true : isMedicalConditionsFeatureEnabled;

    let renderedRows: any;
    let startIndex = 0,
      endIndex = 0;
    if (haveVisits) {
      startIndex = (currentPage - 1) * PAGINATE_PAGE_COUNT;
      endIndex = Math.min(visits.length, currentPage * PAGINATE_PAGE_COUNT);
      const visitsToRender = visits.slice(startIndex, endIndex);
      renderedRows = visitsToRender.map((visit: any) =>
        self._renderRow(
          visit,
          hasBreaks,
          isUpdatingVisits,
          isPendingPaymentDraft,
          isMedicalConditionsFeatureEnabled
        )
      );
    }

    return (
      <div className="vd-list-view">
        {haveVisits && (
          <>
            <div className="vd-buttons-container">
              {(() => {
                const { errors, servicesError } = self.state;
                const errorKeys = Object.keys(errors);

                if (errorKeys.length > 0 || servicesError) {
                  const errIndexes: any = errorKeys.map(
                    (ek) => errors[ek].index + 1
                  );
                  const errCount = errIndexes.length;
                  return (
                    <div className="h vd-draft-error vc">
                      <img
                        alt="error"
                        src="/warning_red.png"
                        className="vd-error-icon"
                      />
                      <div>
                        {errCount
                          ? `Errors found in ${errCount} visits (${errIndexes.join(
                            ", "
                          )})`
                          : ""}
                        {!errCount && servicesError
                          ? `To continue, please select visits with same service requirements.`
                          : ""}
                      </div>
                    </div>
                  );
                }
              })()}
              <Button
                color="primary"
                className="ha-btn-green-outline"
                onClick={() => self.backToUpdateVisit(visits[0]._id)}
              >
                Back
              </Button>

              {!isUpdatingVisits && !isPendingPaymentDraft && (
                <Button
                  variant="contained"
                  color="primary"
                  className="ha-btn-green"
                  onClick={self.saveVisitDrafts}
                >
                  {isSavingDrafts && (
                    <HourglassEmpty
                      fontSize='inherit'
                      className="spin vdl-spin"
                    />
                  )}
                  {!isSavingDrafts && (
                    <img
                      src={
                        draftType === DRAFT_TYPE_MOBILE
                          ? "/mobile-drafts-white.png"
                          : draftType === DRAFT_TYPE_ENTERPRISE
                            ? "/ent-drafts-white.png"
                            : "/visit-drafts-white.png"
                      }
                      alt=""
                      className="vdl-btn-img"
                    />
                  )}
                  Save as draft
                </Button>
              )}

              {!isUpdatingVisits && !isPendingPaymentDraft && (
                <Button
                  variant="contained"
                  color="primary"
                  className="ha-btn-green"
                  onClick={self.handleDelete}
                  disabled={!self.hasSelected()}
                >
                  <img
                    src="/drafts-delete-white.png"
                    alt=""
                    className="vdl-btn-img"
                  />
                  Delete
                </Button>
              )}

              {state._showDiscardUpdateDraft && (
                <Button
                  variant="contained"
                  color="primary"
                  className="ha-btn-green"
                  onClick={self._discardUpdateDraft}
                >
                  Discard Changes
                </Button>
              )}

              <Button
                variant="contained"
                color="primary"
                className="ha-btn-green"
                onClick={self.continueToPricing}
                disabled={!self.hasSelected()}
              >
                <img src="/continue-white.png" alt="" className="vdl-btn-img" />
                Continue
              </Button>
            </div>
            <div className="vd-scroll-container">
              <div className="vd-scroller">
                {/* Header */}
                <div>
                  {/* Checkbox */}
                  <div className="vdl-checkbox">
                    <Checkbox
                      onChange={self.handleAllCheck}
                      className="ha-checkbox"
                      checked={self.state.allChecked}
                    />
                  </div>

                  {/* Date & Time */}
                  <div>Date & Time</div>

                  {/* Visit Timing Flexibility */}
                  <div className="vdl-loc">Visit Timing Flexibility</div>

                  {/* Location */}
                  <div className="vdl-loc">Location</div>

                  {/* ADL Services & Nursing Procedures  & Nurse Requirement & Home Therapy & Home Medical */}
                  <div className="vdl-services" ref={self.medEscRef}>Services</div>

                  {/* Medical Escort Instructions */}
                  {/* <div className="vdl-me">Medical Escort Instructions</div> */}

                  {/* Medical Procedures */}
                  <div className="vdl-mp">Medical Procedures</div>

                  {/* Patient Declaration */}
                  <div className="vdl-pd" ref={self.patientDeclRef}>
                    Patient Declaration
                  </div>

                  {/* Mobility */}
                  <div className="vdl-mob">Mobility</div>

                  {/* Special Instructions */}
                  <div className="vdl-si">Special Instructions</div>

                  {/* Medical Conditions */}
                  {isMedicalConditionsFeatureEnabled && <div className="vdl-mc">Medical Conditions</div>}

                  {/* Add'l Requirements */}
                  <div ref={self.addlReqRef} className="vdl-adreq">
                    Add'l Requirements
                  </div>

                  {/* Break */}
                  {hasBreaks && <div className="vdl-vb">Break</div>}

                  {/* # of CPs */}
                  <div className="vdl-ncp" ref={self.careProDetailsRef}>
                    CP Details
                  </div>

                  {/* CR Notes & Fulfillment Notes  */}
                  <div className="vdl-crn">Notes</div>
                </div>

                {renderedRows}
              </div>
            </div>
            {totalPage > 1 && (
              <div className="h center vdl-pager">
                <span className="vdl-page-info">
                  {startIndex + 1} - {endIndex} of {visits.length}
                </span>
                <img
                  className="arrow bc-arrow"
                  data-disable={currentPage <= 1 ? "" : UNDEF}
                  alt="Previous Page"
                  src="/cal-left-arrow.svg"
                  onClick={self.previousPage}
                />

                <img
                  className="arrow bc-arrow end"
                  data-disable={currentPage >= totalPage ? "" : UNDEF}
                  alt="Next Page"
                  src="/cal-left-arrow.svg"
                  onClick={self.nextPage}
                />
              </div>
            )}
          </>
        )}

        {state._showNoCADialog && (
          <OkCancelDialog
            style={{ maxWidth: "356px" }}
            title="Unable to create visits"
            message={state._errDlgMsg}
            cancelText="Cancel"
            okText="Save as Draft"
            callback={(btn: number) => {
              self.setState({ _showNoCADialog: false });
              btn === 2 && self.saveVisitDrafts();
            }}
          />
        )}

        {state._showCondChangeDialog && (
          <OkCancelDialog
            style={{ maxWidth: "360px" }}
            title="Some things have changed"
            message={state._condChangeMsg}
            cancelText="Discard Changes"
            okText="Continue"
            callback={(btn: number) => {
              if (btn === 1) {
                // Discard Changes
                self._discardUpdateDraft();
              } else if (btn === 2) {
                self._closeConditionsChangeDialog();
              }
            }}
          />
        )}

        {state.pricingEngineOpen && (
          <PortalDialog
            className={`ha-dialog ${self._isPricingUpdate ? "" : "ha-dialog-appear"
              } vdl-pe-popup`}
            disableScroll
          >
            <div className="vdl-dialog-close-container">
              <IconButton
                className="vdl-dialog-close"
                onClick={() => {
                  self.setState({ pricingEngineOpen: false });
                  props.resetPricingAll();
                }}
                aria-label="close"
              >
                <Close />
              </IconButton>
            </div>
            <PricingEngine crInfo={crInfo} coId={props.coId} />
          </PortalDialog>
        )}

        {state.updateReviewOpen && (
          <PortalDialog className="ha-dialog vdl-pe-popup" disableScroll>
            <div className="vdl-dialog-close-container">
              <IconButton
                className="vdl-review-close"
                onClick={() => {
                  self.setState({ updateReviewOpen: false });
                  props.resetPricingAll();
                }}
                aria-label="close"
              >
                <Close />
              </IconButton>
            </div>
            <VisitUpdateReview
              coId={props.coId}
              reviewUpdateData={state._reviewUpdateData}
            />
          </PortalDialog>
        )}

        {!haveVisits && !state.pricingEngineOpen && !state.updateReviewOpen && (
          <div className="vd-list-view no-select">
            <LoadingSpinner></LoadingSpinner>
          </div>
        )}
      </div>
    );
  }
}

// Home Medical can only be selected as standalone option
//  whenever there's adl, nursing procedures or therapy selected, disable the home medical
export function isHomeMedicalDisabled(visit: any): boolean | undefined {
  const haveAdl = (visit[requested_services] || [])[0];
  const haveProcedures = !!(visit[nursing_procedure] || [])[0];
  const haveTherapy = !!(visit[home_rehabilitation] || [])[0];
  return haveAdl || haveProcedures || haveTherapy;
}

// Therapy can only be selected as standalone option
//  whenever there's adl, nursing procedures or home medical selected, disable the therapy
export function isTherapyDisabled(visit: any): boolean | undefined {
  const haveAdl = (visit[requested_services] || [])[0];
  const haveProcedures = !!(visit[nursing_procedure] || [])[0];
  const haveHomeMedical = !!(visit[home_medical] || [])[0];
  return haveAdl || haveProcedures || haveHomeMedical;
}

// is Medical escort details disabled
//  enabled when 'Medical Escort' is selected in ADL Services
export function isMEDetailsDisabled(visit: any) {
  return !(visit[requested_services] || []).includes(MEDICAL_ESCORT);
}

const s_w100 = { width: "100%", position: "relative" };
const s_fs12 = { fontSize: "12px" };
const s_fs13 = { fontSize: "13px", fontWeight: 400 };

const mapStateToProps = (state: any) => {
  const totalVisits = getDraftVisits(state).length;
  return { ...state, totalPage: Math.ceil(totalVisits / PAGINATE_PAGE_COUNT) };
};
const mapDispatchToProps = (dispatch: any) => ({
  setAllVisitChecked: (checked: boolean, type: string) =>
    dispatch(setAllVisitChecked(checked, type)),
  setVisitChecked: (visitId: string, checked: boolean, type: string) =>
    dispatch(setVisitChecked(visitId, checked, type)),
  deleteVisitDrafts: (
    visitDraftIds: Array<string>,
    isDeleteAll: boolean,
    type: string
  ) => dispatch(deleteVisitDrafts(visitDraftIds, isDeleteAll, type)),
  updateLocalVisitDrafts: (updatedObjects: any[], type: string) =>
    dispatch(updateLocalVisitDrafts(updatedObjects, type)),
  saveOrUpdateVisitDrafts: (
    crId: string,
    visitDrafts: Array<any>,
    type: string
  ) => dispatch(saveOrUpdateVisitDrafts(crId, visitDrafts, type)),
  resetPricingAll: () => dispatch(resetPricingAll()),
});

export default withRouter(
  connect<ListViewState, ListViewConnectProps>(
    mapStateToProps,
    mapDispatchToProps
  )(VisitDraftsListView)
);